export const REPORTS_DATA = {
  es: {
    1: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la <strong> inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo </strong>, lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre cómo maneja sus emociones, cómo se relaciona con su entorno y  <strong>cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada muestra un perfil que, si bien posee algunas habilidades emocionales básicas, aún necesita desarrollar  <strong>competencias clave </strong> para enfrentar desafíos y gestionar relaciones de manera efectiva. En este momento, podría encontrarse con dificultades para  <strong>regular sus propias emociones y para interpretar las de los demás, </strong> lo que impacta en la calidad de sus interacciones. Sin embargo, este punto de partida es una oportunidad para trabajar en un crecimiento más consciente y enfocado, con objetivos claros y un plan de acción específico.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área a trabajar',
                description:
                  'La persona evaluada presenta un  <strong>bajo nivel de autoconciencia, </strong> lo que implica que a menudo no reconoce sus propias emociones o cómo estas influyen en su comportamiento. Trabajar en identificar y nombrar sus sentimientos es el primer paso para construir una autoconciencia más fuerte.',
              },
              {
                title: 'Sugerencia',
                description:
                  'Implementar  <strong>ejercicios de diario emocional, </strong> donde anote cómo se siente durante diferentes momentos del día, ayudará a aumentar la percepción de sus estados emocionales y a reconocer patrones repetitivos.',
              },
            ],
          },
          {
            title: 'Autogestión',
            subList: [
              {
                title: 'Área a trabajar',
                description:
                  'La autogestión es  <strong>limitada </strong> en este perfil, y la persona podría experimentar dificultades para controlar sus emociones, especialmente en situaciones de presión o conflicto. Esto podría llevar a reacciones impulsivas que afecten su entorno.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar técnicas de respiración y relajación </strong> antes de momentos desafiantes contribuirá a mejorar su capacidad para mantener la calma y responder de manera más controlada.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Empatía',
            subList: [
              {
                title: 'Área a trabajar',
                description:
                  'En este nivel, la  <strong>empatía aún no está desarrollada, </strong> lo que puede llevar a problemas para entender las perspectivas de otras personas y conectar con sus emociones. Esto podría traducirse en malentendidos o dificultades para construir relaciones de confianza.',
              },
              {
                title: 'Sugerencia',
                description:
                  'Realizar  <strong>ejercicios de "ponerse en el lugar del otro" </strong> y mantener una actitud abierta y no defensiva ante los sentimientos de los demás ayudará a fortalecer esta competencia.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área a trabajar',
                description:
                  'Las habilidades sociales se encuentran en una  <strong>etapa inicial, </strong> con limitaciones para manejar conflictos o influir positivamente en grupos. La persona podría sentirse aislada o tener dificultades para colaborar en equipo.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Participar en actividades de comunicación asertiva y grupos de apoyo </strong> puede ser de gran ayuda para mejorar su confianza y habilidades interpersonales.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área a trabajar',
                description:
                  'La motivación interna es  <strong>baja, </strong> y la persona podría depender de factores externos para sentirse impulsada a alcanzar sus objetivos. Es importante fortalecer la motivación intrínseca para mantener un enfoque constante.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Definir metas pequeñas y alcanzables, y recompensarse por los logros conseguidos, </strong> ayudará a generar una mayor satisfacción y enfoque a largo plazo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Construir una mayor autoconciencia',
            description:
              'Crear un diario emocional para registrar las experiencias y reflexionar sobre qué desencadena ciertas emociones es una práctica fundamental para identificar patrones y aprender a anticipar sus respuestas emocionales.',
          },
          {
            title: 'Desarrollar la resiliencia emocional',
            description:
              'Participar en actividades que fomenten la adaptación a cambios, como juegos de roles y escenarios simulados, ayudará a la persona a aprender a gestionar mejor sus emociones frente a situaciones imprevistas.',
          },
          {
            title: 'Mejorar la empatía a través de la escucha activa',
            description:
              'Realizar ejercicios de escucha activa en entornos controlados, donde se practique el arte de escuchar sin interrumpir, para poder sintonizar más fácilmente con las emociones de los demás.',
          },
          {
            title: 'Fomentar la automotivación',
            description:
              'Crear un "tablero de visión" con imágenes y frases inspiradoras que reflejen sus objetivos personales y profesionales a corto y largo plazo, revisándolo regularmente para mantener la motivación alta.',
          },
          {
            title: 'Aumentar la capacidad de gestión de relaciones',
            description:
              'Participar en grupos de discusión o equipos de voluntariado ayudará a la persona a fortalecer su habilidad para conectarse y colaborar con personas con diferentes estilos y antecedentes.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            title: 'Deportes individuales',
            description:
              'Actividades como el running, natación o ciclismo son recomendables para desarrollar la autodisciplina y la capacidad de automotivación. Estos deportes permiten a la persona concentrarse en su propio progreso y manejar el estrés de manera saludable.',
          },
          {
            pageBreak: true,
            title: 'Yoga o pilates',
            description:
              'Practicar yoga o pilates es muy útil para fomentar el autocontrol y la regulación emocional. Al ser actividades que combinan respiración, estiramientos y relajación, ayudan a calmar la mente y reducir la ansiedad, facilitando un mejor manejo del estrés.',
          },
          {
            title: 'Clubes de lectura o cine',
            description:
              'Participar en grupos de lectura o cine puede mejorar la capacidad de empatía y la escucha activa, al compartir e interpretar diferentes perspectivas. Reflexionar sobre personajes y sus emociones ayuda a entender mejor las experiencias de otros.',
          },
          {
            title: 'Prácticas de mindfulness',
            description:
              'Introducirse en la práctica del mindfulness o la meditación guiada permite desarrollar la autoconciencia, ya que promueve la observación de las emociones y pensamientos sin juzgarlos. Aplicar estas técnicas en el día a día contribuye a una mayor estabilidad emocional.',
          },
          {
            title: 'Serie',
            description:
              '"The Good Place". Esta serie combina humor y filosofía para explorar la naturaleza humana y las emociones. Es ideal para reflexionar sobre la empatía, el sentido de la justicia y el desarrollo personal.',
          },
          {
            title: 'Podcast',
            description:
              '"Entiende Tu Mente". Este podcast en español aborda temas relacionados con la inteligencia emocional y la psicología, ofreciendo estrategias simples y cotidianas para mejorar la autogestión y las relaciones interpersonales. Ideal para trabajar la autoconciencia y la empatía de manera práctica.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Dixit". Este juego estimula la imaginación y la interpretación de emociones a través de ilustraciones, permitiendo desarrollar habilidades como la comunicación, la creatividad y la empatía en un entorno lúdico y relajado.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada tiene una gran oportunidad para desarrollarse en el ámbito de la inteligencia emocional. Con un enfoque en fortalecer su  <strong>autoconciencia, autocontrol y empatía, </strong> podrá empezar a gestionar de manera más efectiva sus emociones y construir relaciones más satisfactorias y constructivas. Este es solo el comienzo de un camino de desarrollo continuo, y con dedicación y perseverancia, podrá alcanzar un mayor equilibrio emocional que le permita desenvolverse con confianza tanto a nivel personal como profesional.',
        ],
      },
    ],
    2: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre cómo maneja sus emociones,  <strong>cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del Perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un  <strong>perfil emocional equilibrado, </strong> con la capacidad de reconocer y gestionar sus emociones en la mayoría de las situaciones. Aunque su autoconciencia es adecuada, aún podría trabajar en comprender mejor cómo sus estados internos afectan sus decisiones. Asimismo, muestra un  <strong>nivel intermedio de empatía y habilidades sociales, </strong> lo que le permite establecer relaciones funcionales, aunque con cierta dificultad para conectar a un nivel más profundo. Este perfil indica que, si bien la persona ha desarrollado una base sólida de competencias emocionales, aún podría  <strong>fortalecer su resiliencia y su capacidad de automotivación, </strong> lo que le permitiría mantener el equilibrio incluso en momentos de alto estrés.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona muestra una  <strong>buena capacidad para reconocer sus emociones </strong> en la mayoría de las situaciones cotidianas, pero podría beneficiarse de un trabajo más enfocado en identificar cómo esos sentimientos afectan sus interacciones y decisiones.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar el monitoreo emocional </strong> durante situaciones de presión, como reuniones importantes o momentos de conflicto, para identificar qué emociones se activan y cómo influyen en su comportamiento.  <strong>Llevar un registro emocional semanal </strong> con foco en situaciones específicas.',
              },
            ],
          },
          {
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La autogestión que posee permite  <strong>responder con control </strong> en la mayoría de las circunstancias. Sin embargo, podría experimentar problemas al gestionar emociones intensas, como frustración o ansiedad.',
              },
              {
                pageBreak: true,
                title: 'Sugerencia',
                description:
                  'Incorporar técnicas de relajación y respiración antes de enfrentarse a tareas desafiantes o decisiones complejas. Asimismo, realizar una  <strong>pausa intencionada (mindful pause) </strong> antes de reaccionar en momentos de estrés.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada muestra un  <strong>nivel de empatía </strong> en donde es capaz de reconocer las emociones ajenas en un entorno social general. Sin embargo, aún podría trabajar en conectar más profundamente, sobre todo en situaciones que demanden mayor comprensión emocional.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la escucha activa, </strong> enfocándose en entender tanto lo que se dice como lo que no se dice (emociones subyacentes). Realizar  <strong>ejercicios de role-playing </strong> para fomentar la capacidad de ponerse en el lugar del otro.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Presenta un  <strong>nivel de habilidades sociales </strong> que le permite interactuar de manera constructiva en contextos formales e informales. Sin embargo, puede sentirse limitado cuando se requiere influir en un grupo o liderar iniciativas.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Participar en actividades grupales </strong> que impliquen liderazgo compartido o coordinación de equipos pequeños para fortalecer su capacidad de influencia y colaboración.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La motivación interna que posee le permite la  <strong>capacidad de mantener el enfoque </strong> en sus objetivos personales. Aun así, podría beneficiarse de una mayor claridad en cuanto a sus valores personales, para alinear sus metas con un propósito más claro.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de establecimiento de metas </strong> a corto y largo plazo que se conecten con sus intereses y valores fundamentales.  <strong>Crear un "mapa de logros" </strong> para visualizar su progreso y mantener una motivación constante.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Desarrollar la autoconciencia',
            description:
              'Realizar prácticas de meditación diaria de 10 a 15 minutos, enfocadas en la observación de pensamientos y emociones, sin juicio.',
          },
          {
            title: 'Fortalecer la resiliencia',
            description:
              'Practicar el manejo del estrés con técnicas que incluyan visualización y regulación emocional.',
          },
          {
            title: 'Potenciar la empatía',
            description:
              'Asistir a talleres o seminarios que aborden la comunicación no verbal y el entendimiento de perspectivas ajenas.',
          },
          {
            title: 'Ampliar habilidades sociales',
            description:
              'Involucrarse en actividades de networking, donde deba interactuar con personas desconocidas y construir nuevas relaciones.',
          },
          {
            title: 'Aumentar la automotivación',
            description:
              'Definir un propósito claro para cada meta y crear un sistema de recompensas personales al alcanzarlas.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            title: 'Deportes individuales',
            description:
              'Actividades como el tenis, gimnasia o la escalada en roca son excelentes para desarrollar la concentración y la resiliencia personal. Estas actividades exigen un enfoque individual y un compromiso constante, lo que ayuda a mejorar la autodisciplina y a gestionar el estrés de manera saludable.',
          },
          {
            pageBreak: true,
            title: 'Actividades de grupo al aire libre',
            description:
              'Participar en deportes de equipo como el fútbol, básquet o voleibol contribuye a fortalecer las habilidades sociales y a desarrollar una mayor empatía. La interacción y el trabajo en equipo permiten a la persona aprender a comunicarse mejor, a escuchar activamente y a colaborar de manera efectiva.',
          },
          {
            title: 'Yoga o Tai Chi',
            description:
              'Practicar yoga o tai chi es útil para fomentar el equilibrio interno y la regulación emocional. Estas actividades combinan respiración, movimientos suaves y meditación, ayudando a reducir la ansiedad y facilitando un mejor manejo del estrés y de las emociones intensas.',
          },
          {
            title: 'Clubes de lectura o debate',
            description:
              'Unirse a un club de lectura o grupo de debate es ideal para desarrollar la capacidad de escucha activa y el pensamiento crítico. Reflexionar sobre distintos puntos de vista y compartir experiencias puede ayudar a mejorar la empatía y a entender mejor las perspectivas de los demás.',
          },
          {
            title: 'Prácticas de mindfulness',
            description:
              'Incorporar la práctica de mindfulness de manera regular puede fortalecer la autoconciencia y mejorar la capacidad para gestionar las emociones. Realizar ejercicios de meditación guiada o de respiración profunda durante 10 minutos cada mañana es un buen punto de partida.',
          },
          {
            title: 'Serie',
            description:
              '"This Is Us". Una serie que explora las emociones humanas, las relaciones familiares y el crecimiento personal a lo largo de la vida. Es ideal para reflexionar sobre la empatía, el manejo de conflictos y el poder del perdón.',
          },
          {
            title: 'Podcast',
            description:
              '"Psicología para Todos". Un podcast en español que ofrece herramientas prácticas y fáciles de aplicar para el desarrollo emocional y la gestión de relaciones. Los episodios abordan temas como la autoconciencia, la empatía y la motivación.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Codenames". Un juego que combina estrategia y comunicación, ideal para trabajar en equipo, afinar las habilidades de observación y potenciar la empatía al interpretar las pistas de otros jugadores en un entorno divertido y distendido.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada presenta un perfil que refleja un  <strong>manejo emocional aceptable </strong> y una  <strong>buena base para el desarrollo de una inteligencia emocional avanzada. </strong> Con un enfoque en trabajar la resiliencia y la empatía, podrá alcanzar un estado de mayor estabilidad emocional y convertirse en un referente en la gestión de relaciones interpersonales. Este es un punto de partida sólido que, con el tiempo y el esfuerzo adecuado, podría evolucionar hacia un nivel de inteligencia emocional sobresaliente.',
        ],
      },
    ],
    3: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre  <strong>cómo maneja sus emociones, cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del Perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta  <strong>un nivel avanzado de empatía y habilidades sociales, </strong> que le permiten establecer relaciones de confianza y comprender las perspectivas de los demás con facilidad. Esta capacidad de sintonizar con las emociones ajenas genera un entorno de apoyo y comunicación abierta. Sin embargo, el perfil "Empático" también podría beneficiarse de  <strong>trabajar en la gestión de sus propias emociones, </strong> para evitar absorber las cargas emocionales de los demás.',
          'La persona evaluada tiene la capacidad de  <strong>adaptarse a diferentes contextos y de detectar las necesidades emocionales </strong> de quienes lo rodean. Aun así, puede experimentar dificultades para separar sus propias emociones de las de los demás, lo que podría llevar a momentos de saturación emocional. Con un enfoque en desarrollar  <strong>habilidades de autogestión y resiliencia, </strong> esta persona podría alcanzar un estado de mayor equilibrio y bienestar emocional.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada muestra un  <strong>nivel de autoconciencia </strong> en donde es capaz de reconocer sus emociones en la mayoría de las situaciones. Sin embargo, puede tener dificultades para distinguir entre sus propios sentimientos y los de las personas con las que interactúa.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar ejercicios de "limpieza emocional" </strong> al final del día, donde se reflexione sobre las emociones experimentadas y se identifique cuáles fueron propias y cuáles fueron absorbidas de los demás.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona puede  <strong>controlar sus respuestas </strong> en la mayoría de las circunstancias, podría beneficiarse de aprender a manejar situaciones de alta carga emocional sin sentirse abrumada.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Incorporar técnicas de relajación progresiva </strong> y establecer  <strong>límites emocionales claros </strong> en contextos de alta demanda emocional (por ejemplo, conversaciones intensas o situaciones de conflicto).',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Su  <strong>empatía </strong> le permite conectar con los demás y crear relaciones interpersonales sólidas. Sin embargo, debe trabajar en no dejarse llevar completamente por las emociones ajenas.',
              },
              {
                title: 'Sugerencia',
                description:
                  'Realizar  <strong>ejercicios de autorreflexión </strong> y aprender a  <strong>decir "no" de manera asertiva  </strong>cuando sienta que las emociones de otras personas empiezan a impactar negativamente en su propio estado emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada puede  <strong>gestionar conflictos con diplomacia </strong> y resolver problemas en equipo de manera eficaz. No obstante, podría enfocarse más en la toma de decisiones asertivas para evitar ser complaciente.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar técnicas de liderazgo asertivo  </strong>y realizar  <strong>simulaciones de toma de decisiones en grupo </strong> para fortalecer su capacidad de influir positivamente sin caer en la sobreprotección de los demás.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>motivación interna  </strong>que tiene impulsa un fuerte deseo de ayudar y generar un impacto positivo en el entorno. Aun así, podría beneficiarse de establecer metas más equilibradas, que consideren tanto sus necesidades como las de las personas a su alrededor.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Definir objetivos personales claros </strong> que no estén únicamente centrados en los demás, sino que reflejen un equilibrio entre el autocuidado y el apoyo a los demás.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fomentar el autocuidado emocional',
            description:
              'Establecer rutinas de desconexión al final del día para liberar las tensiones acumuladas y reenfocarse en sus propias necesidades.',
          },
          {
            title: 'Establecer límites saludables',
            description:
              'Aprender a decir "no" de manera asertiva cuando se perciba que se está sobrecargando emocionalmente.',
          },
          {
            title: 'Practicar la separación emocional',
            description:
              'Implementar la técnica de "anclaje," donde la persona visualiza un símbolo o palabra que le recuerda su propia estabilidad emocional, evitando así ser absorbido por las emociones ajenas.',
          },
          {
            title: 'Fortalecer la motivación intrínseca',
            description:
              'Realizar un listado de objetivos personales que no dependan de la aprobación o satisfacción de los demás, sino que reflejen metas propias.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            title: 'Deportes individuales o de pareja',
            description:
              'El pádel o tenis son ideales para equilibrar la necesidad de conexión con otros sin perder la concentración en uno mismo. Estas actividades ayudan a liberar tensiones y a mantener un enfoque equilibrado entre lo propio y lo compartido.',
          },
          {
            pageBreak: true,
            title: 'Prácticas de meditación guiada',
            description:
              'El uso de aplicaciones como Insight Timer o Headspace puede ser útil para llevar a cabo meditaciones centradas en la autocompasión y el fortalecimiento de límites emocionales.',
          },
          {
            title: 'Clubes de discusión y voluntariado',
            description:
              'Participar en actividades de voluntariado o clubes de discusión temática (literatura, cine, filosofía) ayuda a la persona a seguir conectando con los demás sin perder su propio espacio de reflexión y crecimiento personal.',
          },
          {
            title: 'Serie',
            description:
              '"Atypical". Una serie que explora las emociones, el autismo y la capacidad de cada persona para comprender el mundo de manera única. Ideal para reflexionar sobre la empatía y el manejo de las emociones en situaciones cotidianas.',
          },
          {
            title: 'Podcast',
            description:
              '"Emotions Matter". Un podcast en inglés que aborda diferentes enfoques sobre la inteligencia emocional, con invitados que comparten herramientas para manejar situaciones emocionales complejas y mantener el equilibrio emocional.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"The Mind". Un juego cooperativo donde los jugadores deben sincronizarse sin hablar para colocar cartas en el orden correcto. Es ideal para desarrollar la intuición emocional y la conexión interpersonal.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada muestra una  <strong>capacidad innata para conectar con las emociones ajenas </strong> y construir relaciones basadas en la comprensión y el apoyo mutuo. Estas habilidades le permiten detectar necesidades emocionales en su entorno con facilidad, actuando como un puente entre las personas y promoviendo un ambiente de colaboración y respeto. Sin embargo, esta misma habilidad de empatizar profundamente puede llevar a  <strong>momentos de sobrecarga emocional, </strong> especialmente cuando se involucra en exceso con los problemas de los demás o cuando no establece límites claros para proteger su propio bienestar.',
          'El desafío para la persona evaluada es  <strong>lograr un equilibrio entre brindar apoyo a los demás y preservar su propia estabilidad emocional. </strong> La clave está en fortalecer la autogestión, trabajar en la regulación emocional y aprender a desconectar cuando sea necesario, sin perder la sensibilidad que la caracteriza. Con un desarrollo consciente en estas áreas, la persona evaluada puede alcanzar un estado de mayor resiliencia y claridad emocional, convirtiéndose en un referente positivo en sus entornos personales y profesionales.',
          'Con el tiempo, al perfeccionar sus habilidades de autocuidado y aprender a reconocer cuándo y cómo involucrarse emocionalmente, la persona evaluada podrá  <strong>maximizar su impacto de manera equilibrada. </strong> Esto no solo le permitirá mantener su propia energía y motivación a largo plazo, sino que también inspirará a quienes la rodean a ser más conscientes, compasivos y emocionalmente inteligentes.',
        ],
      },
    ],
    4: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas.</strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre  <strong>cómo maneja sus emociones, cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un perfil que se caracteriza por su  <strong>alta capacidad para trabajar en equipo, su disposición para cooperar y su deseo de fomentar un entorno de apoyo mutuo. </strong> Tiende a priorizar el bienestar del grupo y a crear un ambiente de armonía en el que las personas se sientan incluidas y valoradas. Esta tendencia a colaborar puede facilitar la resolución de problemas y el logro de objetivos comunes de manera eficiente.',
          'Sin embargo, la persona evaluada podría  <strong>beneficiarse de trabajar en su asertividad para no caer en una actitud complaciente o de sacrificio personal por el bien del grupo. </strong> Además, al enfocarse tanto en el trabajo en equipo, puede experimentar dificultades para tomar decisiones en solitario o para priorizar sus propias necesidades. Con un desarrollo consciente de  <strong>habilidades de autogestión y toma de decisiones individuales, </strong> esta persona podría alcanzar un mayor equilibrio entre su deseo de colaborar y su capacidad para mantener un foco personal, asegurando un impacto positivo tanto a nivel grupal como individual.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada muestra un  <strong>nivel de autoconciencia </strong> que le permite una comprensión general de sus emociones en entornos grupales. No obstante, puede perder la conexión con sus propios sentimientos cuando el grupo atraviesa momentos de tensión.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la autoevaluación </strong> al final de cada interacción grupal, identificando sus propios estados emocionales y reflexionando sobre cómo estos influyeron en sus aportes al grupo.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Suele  <strong>regular sus respuestas para evitar conflictos, </strong> pero puede volverse complaciente en situaciones donde se requiere un enfoque más firme.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Desarrollar técnicas de regulación emocional, </strong> como la visualización positiva y el establecimiento de límites, para fortalecer su capacidad de mantener una postura equilibrada incluso cuando el grupo presiona por decisiones rápidas.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Tiene la  <strong>habilidad de ponerse en el lugar de los demás </strong> y de entender las dinámicas emocionales de cada integrante del equipo. Sin embargo, a veces puede sobrecargarse emocionalmente al tratar de mediar en conflictos o resolver problemas ajenos.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Implementar la práctica de "distanciamiento empático," </strong> donde reflexione sobre cuándo involucrarse profundamente y cuándo es mejor adoptar un enfoque más neutral para evitar agotamiento emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene una  <strong>capacidad natural para interactuar de manera efectiva en grupos </strong> y para fomentar la cooperación entre los miembros del equipo. Sin embargo, podría trabajar en tomar un rol de liderazgo más activo cuando la situación lo requiera.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar simulaciones de liderazgo </strong> y participar en proyectos grupales con roles rotativos, lo que le permitirá adquirir más confianza en su capacidad para influir de manera positiva sin perder el enfoque colaborativo.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La motivación interna está  <strong>orientada hacia el logro grupal y la creación de un entorno de bienestar. </strong> Si bien esto impulsa su deseo de colaborar, podría beneficiarse de definir metas individuales que también consideren sus intereses y ambiciones personales.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de establecimiento de objetivos personales </strong> que se alineen con sus valores, pero que no dependan exclusivamente del éxito del equipo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fortalecer la autoconfianza',
            description:
              'Realizar actividades que promuevan la toma de decisiones en solitario, como proyectos personales o situaciones de liderazgo individual.',
          },
          {
            title: 'Fomentar la separación emocional',
            description:
              'Practicar técnicas de mindfulness para reflexionar sobre cuándo tomar un rol activo y cuándo mantenerse en un papel de observador para no verse abrumado por las dinámicas grupales.',
          },
          {
            title: 'Aumentar la capacidad de automotivación',
            description:
              'Crear un sistema de logros personales que se mantenga independiente del éxito grupal, asegurando que las metas individuales también se prioricen.',
          },
          {
            title: 'Ampliar la capacidad de influencia',
            description:
              'Participar en actividades de negociación y resolución de conflictos para fortalecer la capacidad de tomar decisiones difíciles en nombre del grupo.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            title: 'Deportes de equipo',
            description:
              'El fútbol, básquet o el voleibol son ideales para potenciar las habilidades colaborativas, mientras se trabaja la toma de decisiones rápidas y el manejo de la presión en un entorno de grupo.',
          },
          {
            pageBreak: true,
            title: 'Grupos de discusión y debate',
            description:
              'Unirse a grupos de debate es útil para mejorar la capacidad de expresar sus ideas con claridad, al tiempo que se mantiene el respeto y la consideración por las opiniones ajenas.',
          },
          {
            title: 'Prácticas de mindfulness',
            description:
              'El uso de aplicaciones de mindfulness como Headspace o Calm puede ayudar a la persona a reconectar consigo misma después de largas jornadas de interacción grupal.',
          },
          {
            title: 'Serie',
            description:
              '"Brooklyn Nine-Nine". Una serie que aborda de manera humorística las dinámicas de grupo, el trabajo colaborativo y el liderazgo compartido, ideal para reflexionar sobre cómo se manejan las emociones dentro de un equipo.',
          },
          {
            title: 'Podcast',
            description:
              '"The Team Building Show". Un podcast que explora técnicas y estrategias para construir equipos cohesionados, con episodios que abordan temas como la comunicación efectiva, la resolución de conflictos y la motivación grupal.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Pandemic". Un juego cooperativo donde los jugadores deben trabajar juntos para salvar al mundo de una epidemia global. Ideal para desarrollar habilidades de comunicación, planificación y toma de decisiones en equipo.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada presenta una  <strong>gran capacidad para fomentar la colaboración y el apoyo mutuo </strong> en un entorno grupal, actuando como un punto de referencia para el trabajo en equipo. Con su habilidad para generar cohesión y su disposición para ayudar, tiende a priorizar el éxito del grupo por encima del propio. No obstante, es fundamental que también se enfoque en  <strong>desarrollar su autogestión y en definir metas personales claras, </strong> para evitar caer en la complacencia y mantener un equilibrio entre su bienestar individual y el del equipo.',
          'Al trabajar en su asertividad y fortalecer su capacidad para tomar decisiones de manera independiente, la persona evaluada podrá  <strong>maximizar su impacto de manera equilibrada, </strong> asegurando que su enfoque colaborativo no le lleve a sacrificios innecesarios. Con el tiempo, podrá convertirse en un líder que inspire a los demás a colaborar con empatía y efectividad, generando un entorno de trabajo armónico y exitoso para todos.',
        ],
      },
    ],
    5: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención,  <strong>la inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre cómo maneja sus emociones,  <strong>cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un  <strong>nivel avanzado de autoconciencia, </strong> lo que le permite identificar y entender sus propias emociones con facilidad, así como reflexionar sobre cómo estas afectan su comportamiento y sus decisiones. Este nivel de autoconocimiento proporciona una base sólida para la gestión emocional y la toma de decisiones conscientes, lo que resulta en interacciones interpersonales claras y efectivas.',
          'Sin embargo, la persona evaluada podría  <strong>beneficiarse de trabajar en su flexibilidad emocional, </strong> ya que un enfoque excesivamente introspectivo podría llevarla a centrarse demasiado en sus propios estados emocionales y a perder de vista las necesidades y emociones de los demás. En ocasiones, esta tendencia puede dificultar la adaptación a cambios inesperados o a contextos en los que se requiere un enfoque más espontáneo y menos analítico. Con un desarrollo enfocado en la  <strong>regulación emocional y en la ampliación de su perspectiva hacia el entorno, </strong> la persona evaluada podrá alcanzar un nivel aún mayor de inteligencia emocional, gestionando no solo sus propias emociones, sino también conectando de manera más profunda con las de quienes la rodean.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Tiene una  <strong>gran capacidad para reconocer sus emociones y comprender sus causas, </strong> lo que le permite reflexionar sobre sus acciones y mantener un alto nivel de autocrítica positiva.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la autocompasión, </strong> especialmente en momentos de autocrítica excesiva. Realizar  <strong>ejercicios de mindfulness centrados en aceptar sus emociones </strong> sin necesidad de evaluarlas de inmediato puede ser de gran ayuda.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada muestra una  <strong>buena capacidad de autogestión </strong> en la mayoría de las situaciones, pero podría experimentar dificultades para mantenerse flexible en contextos de alta presión o incertidumbre.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Implementar técnicas de adaptación emocional, </strong> como la visualización de posibles resultados y la creación de planes alternativos, para desarrollar una mayor resiliencia ante cambios imprevistos.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Si bien la persona evaluada tiene un  <strong>nivel adecuado de empatía, </strong> su fuerte enfoque en la introspección podría llevarla a centrarse más en sus propias emociones y a dejar de lado, en ocasiones, las señales emocionales de su entorno.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de escucha activa, </strong> enfocándose en interpretar el lenguaje no verbal y los matices emocionales de los demás, para equilibrar su percepción interna con una comprensión más completa de las emociones ajenas.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Las  <strong>habilidades sociales </strong> que posee son adecuadas, especialmente en entornos donde se valoran las conversaciones profundas y el entendimiento mutuo. Sin embargo, la persona evaluada podría trabajar en situaciones que requieran una respuesta rápida y espontánea.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la improvisación </strong> en situaciones controladas, como juegos de roles o simulaciones de interacción en las que deba reaccionar sin un análisis previo, para fomentar una mayor agilidad emocional y comunicacional.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>motivación interna </strong> es sólida y está impulsada por un fuerte deseo de crecimiento personal y autodescubrimiento. Aun así, la persona evaluada podría beneficiarse de definir objetivos que se centren en su entorno y en cómo su desarrollo personal puede impactar positivamente a los demás.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar un plan de desarrollo que combine metas personales con metas relacionales, </strong> de manera que su motivación abarque tanto el crecimiento interno como el impacto externo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fomentar la flexibilidad emocional',
            description:
              'Desarrollar la capacidad de adaptarse a diferentes contextos mediante ejercicios de "mindfulness adaptativo," donde se trabaje la aceptación de cambios y se reflexione sobre cómo responder de manera positiva.',
          },
          {
            title: 'Fortalecer la conexión interpersonal',
            description:
              'Participar en actividades de escucha activa y empatía reflexiva, como talleres de comunicación no verbal y ejercicios de role-playing para ampliar la percepción emocional hacia el entorno.',
          },
          {
            title: 'Aumentar la agilidad emocional',
            description:
              'Realizar ejercicios de improvisación y participación en dinámicas grupales que impliquen respuestas rápidas y espontáneas, para salir de la zona de confort de análisis continuo.',
          },
          {
            title: 'Integrar objetivos personales y relacionales',
            description:
              'Definir metas que incluyan un balance entre el desarrollo propio y el impacto positivo en las personas con las que se interactúa.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            pageBreak: true,
            title: 'Deportes individuales y de equipo',
            description:
              'El tenis, escalada o el fútbol sala pueden ayudar a la persona a desarrollar la capacidad de tomar decisiones rápidas mientras gestiona sus propias emociones. Estas actividades permiten combinar la introspección con la necesidad de acción y reacción inmediata.',
          },
          {
            title: 'Clubes de debate o charlas filosóficas',
            description:
              'Unirse a grupos de debate es ideal para mejorar la capacidad de responder de manera ágil y espontánea a ideas opuestas. Esto ayuda a salir de un enfoque puramente introspectivo y a practicar la escucha activa en entornos desafiantes.',
          },
          {
            title: 'Prácticas de meditación consciente adaptativa',
            description:
              'El uso de meditaciones adaptativas, que se centran en aceptar cambios en el entorno o en las emociones, puede ayudar a la persona evaluada a mejorar su capacidad de adaptación y a gestionar mejor situaciones inesperadas.',
          },
          {
            title: 'Serie',
            description:
              '"The Crown". Una serie que explora el desarrollo personal y el manejo de las emociones en contextos de gran responsabilidad y presión. Ideal para reflexionar sobre la autogestión y la toma de decisiones en momentos críticos.',
          },
          {
            title: 'Podcast',
            description:
              '"Hidden Brain". Un podcast que explora cómo la mente y las emociones afectan las decisiones. Los episodios abordan temas como la autoconciencia, la toma de decisiones y la adaptación emocional, proporcionando herramientas prácticas para el desarrollo personal.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Dixit". Un juego que estimula la interpretación de emociones a través de ilustraciones y metáforas. Ideal para fomentar la flexibilidad emocional y la capacidad de ver diferentes perspectivas sin quedar atrapado en un solo punto de vista.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada demuestra un  <strong>nivel elevado de autoconciencia, </strong> lo que le permite identificar sus emociones de manera clara y reflexionar sobre cómo estas influyen en sus decisiones y relaciones. Esta capacidad de introspección le otorga una ventaja para reconocer sus propios patrones de comportamiento, lo que facilita el desarrollo de estrategias para gestionarse de manera efectiva en distintas situaciones.',
          'Sin embargo, debido a su  <strong>enfoque analítico y su tendencia a reflexionar profundamente, </strong> es posible que en algunos momentos pierda de vista las señales emocionales del entorno o que se muestre menos flexible frente a cambios imprevistos. El desafío principal es  <strong>equilibrar su deseo de autocomprensión con una mayor apertura y adaptación a su entorno, </strong> de manera que no se sienta atrapada en un ciclo de autoevaluación constante que pueda limitar su capacidad para actuar con espontaneidad y fluidez.',
          'Para lograr un desarrollo más integral, es importante que la persona evaluada  <strong>trabaje en su flexibilidad emocional y en fortalecer su conexión con las emociones ajenas. </strong> Aprender a soltar el control cuando sea necesario y aceptar sus propias emociones sin la necesidad de analizarlas en exceso le permitirá mantener un equilibrio saludable entre la reflexión interna y la acción externa.',
          'Con un enfoque en estas áreas, la persona evaluada podrá  <strong>integrar su autoconciencia con una mayor empatía y apertura hacia los demás, </strong> permitiéndole tomar decisiones más equilibradas y reaccionar de manera más ágil y efectiva ante situaciones inesperadas. Esto no solo beneficiará su desarrollo personal, sino que también le permitirá impactar positivamente en su entorno, contribuyendo con su claridad emocional y capacidad para adaptarse a las necesidades del momento.',
        ],
      },
    ],
    6: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre cómo maneja sus emociones,  <strong>cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un  <strong>nivel avanzado de autogestión y regulación emocional. </strong> Esto significa que tiene la capacidad de mantener la calma y el control en la mayoría de las situaciones, incluso en aquellas de alta presión o conflicto. Su enfoque es equilibrado, y suele gestionar sus emociones de manera efectiva, respondiendo con claridad y serenidad en lugar de reaccionar de forma impulsiva. Esta competencia le permite enfrentar desafíos con una actitud proactiva y resolver problemas con mayor claridad y eficiencia.',
          'Sin embargo, debido a su  <strong>fuerte tendencia al control emocional, </strong> la persona evaluada podría experimentar dificultades para expresar libremente sus emociones en situaciones donde se requiere mayor espontaneidad o apertura. A veces, su deseo de mantener la compostura puede llevarla a suprimir sentimientos que necesitan ser comunicados, lo que podría generar tensiones internas o una percepción de rigidez en sus relaciones interpersonales. Con un desarrollo consciente en la  <strong>expresión emocional y en la construcción de un espacio seguro para compartir sus sentimientos de manera más abierta, </strong> la persona evaluada podrá alcanzar un estado de mayor equilibrio, combinando su alta capacidad de regulación con una conexión más profunda y auténtica con su entorno.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene un  <strong>nivel de autoconciencia </strong> que le permite identificar cuándo una emoción surge y cómo esta podría influir en su comportamiento. Sin embargo, a veces podría no darle suficiente espacio a sus sentimientos para manifestarse.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de autoobservación centrados en la expresión emocional. </strong> Identificar momentos en los que se reprime o modera sus emociones y preguntarse cuál sería la manera más equilibrada de manifestarlas sin perder su autogestión.',
              },
            ],
          },
          {
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Posee un  <strong>control significativo sobre sus reacciones emocionales, </strong> lo que le permite manejar conflictos con serenidad y resolver problemas de manera efectiva. Sin embargo, puede volverse demasiado autoexigente cuando se enfrenta a situaciones de alta presión.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar ejercicios de relajación </strong> y realizar  <strong>pausas intencionales para reducir la tensión interna. </strong> Introducir actividades de desconexión, como caminatas o ejercicios de respiración consciente, para evitar el agotamiento por una regulación excesiva.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene un  <strong>nivel de empatía </strong> en donde es capaz de entender cómo sus respuestas impactan en los demás. No obstante, podría trabajar en mostrar su lado emocional de manera más abierta para generar una conexión más auténtica.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de apertura emocional, </strong> como la práctica de compartir experiencias personales en entornos seguros, para fortalecer la empatía a través de una mayor transparencia emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene  <strong>buenas habilidades sociales </strong> y tiende a ser percibida como una persona estable y confiable en entornos de trabajo y en su círculo cercano. Sin embargo, su autocontrol podría ser interpretado como distanciamiento en situaciones que requieren mayor expresión emocional.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar técnicas de comunicación emocional </strong> y participar en grupos de discusión donde se fomente la apertura y el intercambio de sentimientos, para equilibrar su estabilidad con una expresión más visible de sus emociones.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>motivación interna </strong> de la persona evaluada está orientada hacia el logro y la superación personal. Suele mantener un alto nivel de energía y perseverancia, pero podría beneficiarse de enfocarse en metas que también incluyan el desarrollo de su lado emocional.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Definir objetivos </strong> que no solo se centren en la gestión de sus emociones, sino también en el desarrollo de la apertura y la aceptación emocional, buscando un equilibrio entre control y expresión.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fomentar la expresión emocional saludable',
            description:
              'Desarrollar la capacidad de expresar emociones de manera clara y directa mediante técnicas de comunicación asertiva y ejercicios de escritura emocional.',
          },
          {
            title: 'Trabajar en la flexibilidad emocional',
            description:
              'Practicar actividades como juegos de roles o improvisación, donde deba adaptarse rápidamente a cambios de contexto emocional, para romper la tendencia a la rigidez.',
          },
          {
            title: 'Crear un espacio de apertura',
            description:
              'Participar en grupos de apoyo o actividades donde se fomente la apertura emocional y la confianza, para fortalecer la capacidad de compartir sus sentimientos de manera segura.',
          },
          {
            title: 'Fortalecer la conexión interpersonal',
            description:
              'Realizar dinámicas grupales o actividades de voluntariado que requieran la creación de un vínculo emocional con los demás, equilibrando la regulación con una mayor conexión empática.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            title: 'Deportes que combinan autocontrol y expresión',
            description:
              'El yoga, boxeo o el tai chi son ideales para equilibrar el control y la liberación emocional. Estas actividades ayudan a la persona a mantener su estabilidad interna, al tiempo que permiten una mayor expresión a través del movimiento.',
          },
          {
            pageBreak: true,
            title: 'Prácticas de escritura emocional',
            description:
              'Escribir en un diario emocional o realizar ejercicios de escritura libre puede ayudar a la persona evaluada a explorar y expresar sentimientos que usualmente mantiene bajo control. Reflexionar sobre sus emociones a través de la escritura puede ser una forma efectiva de soltar la tensión emocional acumulada.',
          },
          {
            title: 'Clubes de expresión creativa',
            description:
              'Unirse a grupos de teatro, talleres de arte o clases de improvisación es ideal para trabajar en la apertura y la flexibilidad emocional en un entorno seguro y guiado, permitiendo a la persona explorar nuevas formas de expresar sus emociones.',
          },
          {
            title: 'Serie',
            description:
              '"This Is Us". Una serie que explora las emociones humanas de manera profunda y honesta. Ideal para reflexionar sobre la importancia de la expresión emocional y cómo las dinámicas familiares impactan la regulación de las emociones.',
          },
          {
            title: 'Podcast',
            description:
              '"The Science of Happiness". Un podcast que aborda estrategias basadas en la ciencia para mantener un equilibrio emocional, con episodios centrados en cómo gestionar las emociones y desarrollar un bienestar integral.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Codenames". Un juego que combina estrategia y comunicación, ideal para trabajar en equipo y practicar la paciencia y la claridad en la expresión, manteniendo el control sin perder la espontaneidad.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada posee una  <strong>gran capacidad para manejar sus emociones de manera efectiva, </strong> manteniendo la calma y el control incluso en situaciones de alta presión. Esta habilidad le permite tomar decisiones claras y equilibradas, lo que la convierte en un referente de estabilidad y confiabilidad en su entorno. Gracias a su capacidad de autogestión, suele enfrentar los desafíos con serenidad y actúa de forma proactiva para resolver problemas sin dejarse llevar por impulsos o reacciones emocionales negativas.',
          'Sin embargo, el <strong>fuerte control emocional que ejerce también puede llevarla a reprimir sus propios sentimientos </strong> o a mostrarse demasiado reservada en situaciones que requieren una mayor expresión emocional y autenticidad. Esta tendencia a mantener siempre la compostura podría dificultar la creación de relaciones más profundas y cercanas, ya que los demás pueden percibirla como distante o inaccesible en contextos que requieren una mayor apertura emocional.',
          'Para alcanzar un desarrollo emocional más completo, es importante que la persona evaluada  <strong>trabaje en encontrar un equilibrio entre la regulación y la expresión. </strong> Aprender a comunicar sus emociones de manera más abierta y mostrar su lado vulnerable en un entorno seguro le permitirá fortalecer sus relaciones interpersonales y crear un espacio de mayor confianza mutua. La clave está en aceptar que mostrar sus sentimientos no es un signo de debilidad, sino una forma de conectar de manera auténtica con los demás.',
          'Con el tiempo, al integrar su capacidad de regulación con una expresión emocional más libre y sincera, la persona evaluada podrá  <strong>alcanzar un equilibrio más profundo y convertirse en un modelo no solo de estabilidad, sino también de apertura y cercanía. </strong> Esto no solo beneficiará su desarrollo personal, sino que también le permitirá influir positivamente en su entorno, generando un ambiente en el que el autocontrol y la expresión emocional convivan de manera armónica, promoviendo relaciones basadas en la confianza, el respeto y la empatía.',
        ],
      },
    ],
    7: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre  <strong>cómo maneja sus emociones, cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un  <strong>nivel alto de motivación interna, </strong> lo que significa que se siente impulsada por metas y objetivos que van más allá de factores externos. Su capacidad para automotivarse y mantenerse enfocada le permite abordar proyectos con entusiasmo y persistencia, mostrando un fuerte deseo de alcanzar resultados positivos. Esta energía constante le otorga un impulso adicional para enfrentar desafíos y superarse a sí misma, lo que la convierte en alguien orientado al logro y con un espíritu de superación.',
          'Sin embargo, este nivel de motivación podría llevar a la persona evaluada a veces a  <strong>priorizar el cumplimiento de sus objetivos por encima de su bienestar personal, </strong> especialmente cuando se encuentra bajo presión. Además, su impulso constante por alcanzar nuevas metas podría hacerle difícil disfrutar del proceso y desconectarse de manera adecuada, generando un riesgo de agotamiento o desmotivación cuando las cosas no salen según lo planeado. Para alcanzar un equilibrio más saludable, la persona evaluada podría  <strong>beneficiarse de trabajar en su capacidad para gestionar la frustración y aprender a disfrutar de los pequeños logros </strong> en el camino hacia sus objetivos principales. Con un enfoque en desarrollar un mayor autocuidado y una perspectiva más flexible, podrá mantener su nivel de motivación alto sin comprometer su bienestar emocional.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada muestra una  <strong>buena capacidad para reconocer sus propias metas </strong> y lo que la impulsa a alcanzarlas. Sin embargo, podría beneficiarse de un trabajo adicional para identificar cuándo su motivación comienza a cruzar el límite hacia la autoexigencia.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Incorporar ejercicios de reflexión </strong> al final de cada semana para evaluar qué logros se han obtenido y qué aprendizajes se han generado, permitiéndose celebrar las pequeñas victorias y no solo los grandes resultados.',
              },
            ],
          },
          {
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>autogestión es sólida, </strong> permitiendo a la persona mantenerse enfocada en sus objetivos y gestionar sus emociones en función de lo que necesita lograr. No obstante, podría trabajar en ser más flexible con las metas y en aprender a ajustarse a los cambios sin que esto afecte su motivación.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la creación de planes alternativos (Plan B y C) </strong> al diseñar sus objetivos, para desarrollar una mayor resiliencia y aceptación cuando se presentan contratiempos.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Si bien la persona evaluada tiene la  <strong>capacidad de empatizar </strong> con quienes la rodean, su fuerte orientación al logro podría llevarla a centrarse más en sus propios objetivos que en las necesidades emocionales de los demás.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de "revisión empática" </strong> donde, después de cada proyecto o interacción grupal, reflexione sobre el impacto emocional que tuvo en los demás y cómo podría equilibrar mejor sus metas con las de su entorno.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada posee  <strong>buenas habilidades sociales </strong> y tiende a ser percibida como alguien con gran energía y entusiasmo, capaz de contagiar a los demás con su espíritu de superación. Sin embargo, podría trabajar en ser más paciente y comprensiva cuando los demás no comparten el mismo nivel de motivación.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la escucha activa </strong> en contextos de equipo, permitiendo que otros compartan sus puntos de vista sin interrumpir, para desarrollar una mayor capacidad de contención y comprensión hacia distintas perspectivas.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Siente una  <strong>energía constante y un deseo innato por lograr sus metas </strong> y desarrollarse continuamente. Sin embargo, este alto nivel de motivación también podría convertirse en un arma de doble filo si no se acompaña de un equilibrio entre logro y disfrute.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Incorporar momentos de descanso programado </strong> y celebrar cada avance como un éxito en sí mismo, para mantener la motivación sin generar agotamiento a largo plazo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fomentar la flexibilidad emocional',
            description:
              'Aprender a adaptar sus metas y expectativas cuando las circunstancias cambian, sin que esto afecte su motivación de manera negativa.',
          },
          {
            title: 'Desarrollar la autocompasión',
            description:
              'Incorporar prácticas de autocompasión para evitar la autoexigencia excesiva, especialmente en momentos de frustración o cuando los objetivos no se logran a la primera.',
          },
          {
            title: 'Crear un balance entre logro y bienestar',
            description:
              'Definir momentos específicos de desconexión y descanso durante la semana para disfrutar de otras actividades que no estén relacionadas con sus objetivos principales.',
          },
          {
            title: 'Fortalecer la conexión interpersonal',
            description:
              'Participar en actividades grupales donde se valore el proceso colaborativo más que el resultado final, para desarrollar una mayor conexión con su entorno.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            title: 'Deportes que involucren metas y superación personal',
            description:
              'El running, crossfit o el triatlón son ideales para mantener el enfoque en objetivos de crecimiento personal y medir el progreso de manera constante. Sin embargo, es importante acompañar estos deportes con actividades de relajación para evitar el agotamiento.',
          },
          {
            pageBreak: true,
            title: 'Actividades de equipo con enfoque en procesos',
            description:
              'Participar en equipos deportivos recreativos (por ejemplo, voleibol o fútbol amateur) donde el objetivo principal no sea ganar, sino disfrutar del proceso, ayudará a la persona evaluada a mantener el equilibrio entre motivación y disfrute.',
          },
          {
            title: 'Prácticas de mindfulness enfocadas en el aquí y ahora',
            description:
              'Introducir la práctica de mindfulness para centrarse en el presente sin perder de vista las metas a largo plazo. Aplicaciones como Headspace o Calm pueden ser útiles para crear una rutina de mindfulness que fomente el equilibrio emocional.',
          },
          {
            title: 'Serie',
            description:
              '"Chef\'s Table". Una serie que explora la motivación y la pasión de chefs de renombre mundial. Ideal para reflexionar sobre el proceso creativo y cómo se combinan el esfuerzo, la motivación y el bienestar personal para alcanzar la excelencia.',
          },
          {
            title: 'Podcast',
            description:
              '"The Tim Ferriss Show". Un podcast que aborda la motivación, la productividad y el desarrollo personal, con entrevistas a personas de alto rendimiento que comparten sus estrategias para mantenerse motivados y equilibrados.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Azul". Un juego estratégico que requiere planificación y precisión para completar patrones. Es ideal para trabajar la paciencia, el enfoque y la flexibilidad emocional cuando las metas no se alcanzan de inmediato.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada muestra un  <strong>alto nivel de motivación interna, </strong> lo que le permite enfrentar desafíos con energía y persistencia, manteniendo un enfoque constante en sus metas. Su deseo de alcanzar objetivos y superarse a sí misma impulsa un espíritu de crecimiento y desarrollo continuo, convirtiéndola en alguien con gran capacidad para inspirar a quienes la rodean. Además, esta fuerte orientación al logro le otorga una ventaja significativa en contextos competitivos y le permite mantener una actitud positiva incluso frente a obstáculos y dificultades.',
          'Sin embargo, este  <strong>alto nivel de motivación también conlleva ciertos desafíos. </strong> La persona evaluada podría encontrarse en ocasiones priorizando sus metas por encima de su bienestar personal, o incluso sintiendo una presión constante para rendir al máximo, lo que podría llevarla a la autoexigencia excesiva o al agotamiento. La clave para alcanzar un desarrollo emocional equilibrado está en aprender a aceptar que el descanso y la desconexión también forman parte del camino hacia el éxito y que no todos los avances se miden en términos de productividad o resultados inmediatos.',
          'El desafío para la persona evaluada es  <strong>encontrar un balance donde su motivación no se vea afectada por los contratiempos y donde el proceso de alcanzar metas sea tan satisfactorio como el logro mismo. </strong> Al integrar momentos de reflexión y autocuidado, podrá aprender a disfrutar del camino, celebrando cada pequeño paso como una victoria en sí misma. Esta integración le permitirá mantener su energía alta y su motivación constante sin comprometer su bienestar emocional, asegurando un progreso sostenible a largo plazo.',
          'Con el tiempo, al perfeccionar su capacidad para equilibrar el impulso hacia el logro con un mayor disfrute del presente, la persona evaluada podrá  <strong>convertirse en un referente de motivación saludable y bienestar integral. </strong> No solo alcanzará sus metas de manera más consciente y plena, sino que también inspirará a otros a buscar un enfoque equilibrado, demostrando que la verdadera motivación no se basa en la constante búsqueda de resultados, sino en la capacidad de mantener la pasión y la energía a lo largo de todo el camino.',
        ],
      },
    ],
    8: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre  <strong>cómo maneja sus emociones, cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un  <strong>perfil altamente estratégico, </strong> con una capacidad avanzada para planificar y organizar tanto sus emociones como sus acciones de manera que se alineen con sus objetivos a largo plazo. Suele ser una persona con una gran visión y enfoque, lo que le permite anticipar posibles obstáculos y adaptarse rápidamente a los cambios. Esta habilidad le permite responder de manera equilibrada y lógica a situaciones complejas, abordándolas con una mentalidad analítica y resolutiva.',
          'Sin embargo, esta  <strong>fuerte orientación estratégica </strong> también puede llevar a que la persona evaluada se centre excesivamente en los resultados y pierda de vista la importancia del proceso y las relaciones interpersonales en el camino hacia sus objetivos. Además, su enfoque en la planificación y la eficiencia podría hacer que, en ocasiones, se muestre menos flexible ante situaciones que requieren improvisación o espontaneidad. Para alcanzar un desarrollo más equilibrado, la persona evaluada podría  <strong>beneficiarse de trabajar en ser más abierta a la incertidumbre y en aceptar que no todo se puede prever o planificar. </strong> Aprender a adaptarse a situaciones inesperadas con una mayor apertura emocional y a valorar las experiencias en el presente le permitirá no solo alcanzar sus objetivos, sino también disfrutar más del camino.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada muestra un  <strong>nivel de autoconciencia </strong> en donde la capacidad de identificar sus emociones y comprender cómo estas influyen en sus decisiones estratégicas. No obstante, podría trabajar en reconocer cuándo su enfoque analítico comienza a limitar su apertura a nuevas experiencias.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la autoobservación </strong> durante momentos de improvisación o cambios inesperados, identificando cómo su mente busca controlar la situación y explorando formas de aceptar la incertidumbre con mayor flexibilidad.',
              },
            ],
          },
          {
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'Posee una  <strong>gran capacidad para regular sus emociones </strong> y mantenerse enfocada en sus metas, incluso en situaciones de alta presión. Sin embargo, podría beneficiarse de aprender a incorporar momentos de relajación y descanso para evitar una planificación excesiva que genere rigidez.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Establecer momentos específicos de desconexión </strong> en su rutina diaria, donde pueda permitirse actuar de manera espontánea sin un plan predeterminado, para equilibrar la estructura con la flexibilidad.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada es  <strong>capaz de entender las emociones ajenas </strong> y anticipar cómo sus acciones impactan en el entorno. Sin embargo, podría trabajar en mostrar una mayor apertura emocional y autenticidad para construir relaciones más cercanas y no solo basadas en objetivos compartidos.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Participar en actividades que fomenten la expresión emocional, </strong> como talleres de comunicación efectiva y grupos de debate centrados en la conexión personal, para equilibrar su enfoque lógico con una mayor sensibilidad emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene  <strong>buenas habilidades sociales, </strong> con una gran capacidad para influir positivamente en otros a través de una comunicación clara y enfocada. No obstante, su enfoque en la eficiencia y el logro de objetivos podría ser interpretado como frialdad o distancia en ciertos contextos.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar técnicas de comunicación emocional, </strong> donde el foco no esté en el resultado final, sino en compartir experiencias y sentimientos de manera más abierta y relajada, para fortalecer sus relaciones personales.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>motivación interna </strong> de la persona evaluada está orientada hacia el logro de metas significativas. Sin embargo, podría beneficiarse de trabajar en metas que no solo se centren en el éxito personal, sino también en el desarrollo de un equilibrio entre su vida profesional y personal.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Definir metas a corto plazo </strong> que incluyan el disfrute de actividades no relacionadas con su desarrollo estratégico, para mantener una motivación más equilibrada y sostenible a largo plazo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fomentar la apertura a la incertidumbre',
            description:
              'Aprender a aceptar que no todo puede ser planificado, permitiéndose ser más flexible y abierto a lo inesperado. Practicar la toma de decisiones rápidas en situaciones donde no tiene el control total ayudará a fortalecer esta área.',
          },
          {
            title: 'Trabajar en la expresión emocional',
            description:
              'Participar en actividades que requieran compartir experiencias personales y emociones sin un objetivo predeterminado, como talleres de creatividad o escritura emocional.',
          },
          {
            title: 'Desarrollar una perspectiva más holística',
            description:
              'Fomentar el disfrute del proceso y no solo del resultado final. Realizar actividades recreativas que no impliquen una planificación estricta ayudará a liberar la mente y a reducir la rigidez.',
          },
          {
            title: 'Fortalecer las relaciones interpersonales',
            description:
              'Involucrarse en dinámicas grupales que se centren más en la conexión emocional que en la consecución de metas, para equilibrar el enfoque estratégico con una mayor apertura interpersonal.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            pageBreak: true,
            title: 'Deportes de estrategia y espontaneidad',
            description:
              'El ajedrez, bádminton o el paintball son ideales para desarrollar la capacidad de anticipación y estrategia. Sin embargo, se recomienda combinarlos con actividades de reacción rápida y espontánea, como el pádel o el béisbol, para fomentar la adaptabilidad.',
          },
          {
            title: 'Prácticas de improvisación teatral',
            description:
              'Participar en talleres de teatro de improvisación es una excelente manera de trabajar en la flexibilidad emocional y la capacidad de respuesta rápida sin un plan previo.',
          },
          {
            title: 'Actividades creativas sin estructura definida',
            description:
              'Realizar talleres de pintura libre, clases de danza o fotografía sin guión puede ayudar a la persona evaluada a salir de su zona de confort y explorar nuevas formas de expresión sin la necesidad de un resultado específico.',
          },
          {
            title: 'Serie',
            description:
              '"Billions". Una serie que explora la complejidad de la toma de decisiones estratégicas y el impacto emocional que estas tienen en las relaciones personales y profesionales. Ideal para reflexionar sobre cómo el enfoque estratégico afecta la vida en general.',
          },
          {
            title: 'Podcast',
            description:
              '"Freakonomics Radio". Un podcast que explora el lado oculto de la toma de decisiones y cómo las estrategias influyen en distintos aspectos de la vida. Ideal para mantener el interés en la estrategia mientras se fomenta una perspectiva más amplia.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Risk". Un juego clásico de estrategia y conquista que requiere una planificación cuidadosa y flexibilidad para adaptarse a los movimientos de los demás jugadores. Ideal para combinar el pensamiento estratégico con la adaptabilidad.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada demuestra un  <strong>alto nivel de habilidades estratégicas y de planificación, </strong> lo que le permite anticiparse a los desafíos y diseñar soluciones claras y efectivas. Gracias a su capacidad analítica, puede tomar decisiones informadas y mantener un enfoque orientado a resultados, incluso en entornos complejos. Esto la convierte en un referente para gestionar proyectos de manera estructurada, garantizando que cada paso esté alineado con un objetivo claro.',
          'Sin embargo, su  <strong>fuerte orientación hacia la estrategia y la eficiencia </strong> puede hacer que, en ocasiones, priorice los resultados por encima de las relaciones interpersonales o el disfrute del proceso. Es fundamental que trabaje en  <strong>desarrollar una mayor flexibilidad y apertura hacia lo inesperado, </strong> aprendiendo a valorar tanto el camino como la meta. Al integrar su capacidad de planificación con una mayor sensibilidad hacia el presente, la persona evaluada podrá alcanzar un equilibrio más saludable y efectivo en sus decisiones.',
          'Al encontrar este balance, no solo podrá mantener su alto rendimiento, sino que también se convertirá en un referente de liderazgo que inspira a otros a combinar la claridad estratégica con una conexión más profunda y auténtica con el entorno. Así, la persona evaluada logrará un impacto positivo que va más allá del éxito individual, generando relaciones interpersonales basadas en la confianza y el respeto.',
        ],
      },
    ],
    9: [
      {
        title: 'Introducción',
        content: [
          'En un mundo cada vez más competitivo, donde las habilidades técnicas y el conocimiento académico suelen acaparar la atención, la  <strong>inteligencia emocional </strong> ha surgido como un factor clave que diferencia a las personas en su éxito tanto personal como profesional. Más allá de lo que se puede aprender en libros o cursos, la inteligencia emocional es lo que permite a las personas  <strong>manejar sus emociones, entender las de los demás y construir relaciones interpersonales sólidas y efectivas. </strong> Este concepto, popularizado por el psicólogo Daniel Goleman, abarca una serie de  <strong>competencias </strong> que incluyen la capacidad de  <strong>reconocer, comprender y gestionar las propias emociones, así como influir positivamente en las emociones de los demás. </strong> Lo interesante de la inteligencia emocional es que, a diferencia de algunas habilidades innatas,  <strong>puede desarrollarse y perfeccionarse con el tiempo, </strong> lo que la convierte en un recurso invaluable en cualquier contexto, ya sea personal o laboral.',
          'Nawaiam no solo se enfoca en evaluar comportamientos y habilidades a través de su innovador enfoque de gamificación, sino que también puede ser una herramienta poderosa para ayudar a las personas a  <strong>descubrir y desarrollar su inteligencia emocional. </strong> A través de nuestro videojuego, cada persona tiene la oportunidad de reflexionar sobre  <strong>cómo maneja sus emociones, cómo se relaciona con su entorno y cómo puede mejorar en estas áreas para alcanzar su máximo potencial. </strong> Desde el manejo del estrés hasta la toma de decisiones efectivas y la creación de ambientes de trabajo más armónicos, la inteligencia emocional es el catalizador que impulsa tanto el crecimiento individual como el colectivo. En Nawaiam, creemos que el autoconocimiento y el desarrollo emocional no solo generan mejores profesionales, sino también individuos más conscientes, empáticos y resilientes.',
        ],
      },
      {
        title: 'Descripción del perfil de Inteligencia Emocional',
        content: [
          'La persona evaluada presenta un  <strong>perfil de Líder Inspiracional, </strong> caracterizado por su capacidad para motivar, guiar y generar un impacto positivo en los demás a través de sus acciones y palabras. Suele destacarse por su habilidad para transmitir su visión con entusiasmo y convicción, lo que le permite crear un entorno de motivación y confianza donde los demás se sienten inspirados a seguir su ejemplo. Esta combinación de motivación interna y habilidades sociales avanzadas le otorga una influencia significativa, permitiéndole conectar con las personas de manera auténtica y empática.',
          'Sin embargo, la persona evaluada también podría enfrentar desafíos relacionados con la  <strong>gestión de sus propias expectativas y la tendencia a asumir un rol de apoyo constante para los demás. </strong> Esta inclinación hacia la inspiración y el liderazgo podría llevarla a priorizar las necesidades ajenas por encima de las propias, corriendo el riesgo de agotamiento emocional o de no permitirse el tiempo suficiente para reflexionar sobre su propio bienestar. Para alcanzar un desarrollo más equilibrado, es fundamental que la persona evaluada  <strong>trabaje en la autogestión y en el establecimiento de límites saludables, </strong> asegurando que su motivación por apoyar e inspirar no se convierta en una carga. Al encontrar un equilibrio entre su impulso por liderar y su autocuidado, podrá continuar inspirando a quienes la rodean sin comprometer su propio bienestar.',
        ],
      },
      {
        title: 'Competencias Emocionales',
        content: [],
        list: [
          {
            title: 'Autoconciencia',
            description: '',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene un  <strong>nivel de autoconciencia </strong> que le permite identificar sus emociones con claridad y entender cómo estas influyen en su estilo de liderazgo. Sin embargo, podría beneficiarse de un trabajo más profundo en la identificación de sus límites personales.',
              },
              {
                pageBreak: true,
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la autoevaluación </strong> al final de cada jornada para identificar qué emociones se generaron durante el día y qué situaciones podrían haberse gestionado con mayor equilibrio entre el apoyo a otros y el cuidado propio.',
              },
            ],
          },
          {
            title: 'Autogestión',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene una  <strong>gran capacidad para gestionar sus respuestas emocionales </strong> y mantenerse enfocada en sus objetivos, incluso en entornos de alta presión. Sin embargo, podría trabajar en crear momentos específicos de desconexión para evitar el agotamiento por su alto nivel de compromiso.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Incorporar descansos planificados </strong> en su rutina y actividades de relajación que le permitan renovar su energía sin sentirse culpable por no estar siempre disponible para los demás.',
              },
            ],
          },
          {
            title: 'Empatía',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>empatía es uno de los puntos más fuertes </strong> de la persona evaluada, lo que le permite conectar de manera auténtica con los demás y entender sus necesidades. No obstante, podría trabajar en equilibrar su deseo de ayudar con la capacidad de mantenerse firme en sus propias decisiones.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Practicar la escucha activa </strong> sin asumir el rol de "solucionador" de todos los problemas, permitiendo que los demás también desarrollen su propia autonomía.',
              },
            ],
          },
          {
            title: 'Habilidades Sociales',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La persona evaluada tiene  <strong>excelentes habilidades sociales, </strong> siendo percibida como una figura de apoyo y guía para quienes la rodean. Su capacidad para transmitir mensajes de manera efectiva y motivar a los demás es notable, pero podría beneficiarse de enfocarse más en delegar responsabilidades para no asumir todo el peso del liderazgo.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Realizar ejercicios de delegación </strong> en grupos de trabajo o en proyectos personales, cediendo el liderazgo en algunas ocasiones para fomentar la autogestión en el equipo.',
              },
            ],
          },
          {
            title: 'Motivación Interna',
            subList: [
              {
                title: 'Área actual',
                description:
                  'La  <strong>motivación interna </strong> de la persona evaluada es excepcional, impulsada por un deseo genuino de alcanzar sus metas y ayudar a los demás a lograr las suyas. Sin embargo, este nivel de motivación puede llevarla a ignorar señales de agotamiento.',
              },
              {
                title: 'Sugerencia',
                description:
                  ' <strong>Definir objetivos de autocuidado </strong> como parte de su plan de desarrollo, asegurando que su motivación no se traduzca únicamente en logros externos, sino también en bienestar personal.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientación, Apoyo y Recomendaciones',
        content: [
          'En este apartado, vamos a charlar sobre cómo la persona evaluada puede seguir desarrollándose a través de algunas recomendaciones prácticas. Exploraremos tanto estrategias específicas para potenciar sus competencias emocionales como actividades complementarias, como deportes, entretenimiento y recursos de aprendizaje.',
        ],
        list: [
          {
            title: 'Fomentar el autocuidado',
            description:
              'Establecer rutinas de autocuidado que incluyan tanto actividades recreativas como momentos de reflexión personal, para evitar el agotamiento emocional.',
          },
          {
            title: 'Trabajar en la delegación de responsabilidades',
            description:
              'Aprender a delegar tareas de manera efectiva, permitiendo que otros asuman roles de liderazgo bajo su guía y apoyo.',
          },
          {
            title: 'Fortalecer la autonomía emocional',
            description:
              'Establecer límites claros y recordar que cuidar de sí mismo es parte del liderazgo, asegurando que su deseo de apoyar no se convierta en una carga excesiva.',
          },
          {
            title:
              'Equilibrar el deseo de ayudar con la capacidad de decir "no"',
            description:
              'Practicar técnicas de asertividad para expresar cuándo necesita tiempo para sí mismo, sin perder su espíritu de apoyo y liderazgo.',
          },
        ],
      },
      {
        title: 'Recomendaciones Adicionales',
        content: [
          'Para complementar el desarrollo de sus competencias emocionales, es fundamental que se mantenga activo tanto física como mentalmente. Aquí algunas sugerencias que pueden potenciar sus habilidades:',
        ],
        list: [
          {
            pageBreak: true,
            title: 'Deportes que combinan liderazgo y colaboración',
            description:
              'Actividades como el fútbol, básquet o el remo en equipo permiten a la persona ejercitar sus habilidades de liderazgo en un entorno donde el éxito depende de la colaboración. Estas actividades ayudan a equilibrar la motivación interna con la capacidad de confiar en los demás para alcanzar objetivos conjuntos.',
          },
          {
            title: 'Prácticas de relajación activa',
            description:
              'El yoga o el tai chi son ideales para mantener un enfoque en el bienestar físico y mental, al tiempo que permiten un espacio para la autorreflexión y la renovación de energía.',
          },
          {
            title: 'Actividades de voluntariado guiadas',
            description:
              'Participar en proyectos de voluntariado donde pueda guiar a otros sin asumir todo el peso del liderazgo es ideal para equilibrar su deseo de ayudar con la capacidad de delegar y fomentar la autonomía de los demás.',
          },
          {
            title: 'Serie',
            description:
              '"The West Wing". Una serie que explora el liderazgo, la toma de decisiones y el impacto que tiene un líder en su entorno. Ideal para reflexionar sobre cómo equilibrar la motivación interna con el autocuidado y el manejo de las expectativas.',
          },
          {
            title: 'Podcast',
            description:
              '"HBR IdeaCast". Un podcast que aborda temas de liderazgo, motivación y equilibrio personal, con herramientas prácticas para mejorar la capacidad de influir positivamente sin comprometer el propio bienestar.',
          },
          {
            title: 'Juego de mesa',
            description:
              '"Pandemic: Legacy". Un juego cooperativo donde el equipo debe trabajar en conjunto para superar desafíos globales. Ideal para practicar la toma de decisiones colaborativa y fortalecer la capacidad de delegar responsabilidades.',
          },
        ],
      },
      {
        title: 'Conclusión',
        content: [
          'La persona evaluada muestra un  <strong>nivel excepcional de habilidades de liderazgo y motivación, </strong> lo que la convierte en un referente natural para quienes la rodean. Su capacidad para guiar a los demás con entusiasmo, transmitir su visión de manera clara y generar un entorno de apoyo y confianza le otorga un alto nivel de influencia positiva en cualquier contexto. Esta combinación de motivación interna y habilidades sociales avanzadas no solo impulsa su propio crecimiento, sino que también crea un impacto profundo en quienes la siguen, motivándolos a alcanzar sus propios objetivos y a desarrollar su potencial.',
          'Sin embargo, su  <strong>fuerte deseo de apoyar y guiar a los demás puede llevarla a asumir responsabilidades adicionales </strong> o a anteponer las necesidades de su entorno por encima de las propias, generando un riesgo de agotamiento emocional o de desmotivación cuando siente que no puede cumplir con las expectativas que se autoimpone. Este impulso constante por ser una fuente de inspiración y apoyo podría, en ocasiones, hacer que la persona evaluada descuide su propio bienestar y se sienta atrapada en un ciclo de autoexigencia y falta de tiempo personal.',
          'Para mantener su capacidad de liderazgo a largo plazo, es importante que la persona evaluada  <strong>aprenda a establecer límites saludables y a equilibrar su rol de apoyo con un espacio dedicado al autocuidado y a la reflexión personal. </strong> Aprender a delegar responsabilidades, permitiendo que otros también asuman roles de liderazgo, y aceptar que no siempre debe ser la fuente principal de motivación puede ayudarle a reducir la carga emocional que siente y a preservar su energía para momentos realmente cruciales.',
          'Con el tiempo, al perfeccionar su capacidad de  <strong>equilibrar su motivación interna con el autocuidado, </strong> la persona evaluada podrá convertirse en un modelo de liderazgo sostenible y equilibrado. No solo podrá seguir inspirando a otros con su visión y su ejemplo, sino también demostrar que el verdadero liderazgo se basa en saber cuándo guiar y cuándo dar un paso atrás para permitir que otros crezcan. Este enfoque no solo le permitirá mantener un nivel alto de energía y compromiso, sino que también contribuirá a crear un entorno en el que todos se sientan capacitados y motivados a contribuir.',
          'En última instancia, la persona evaluada podrá continuar influyendo positivamente en su entorno, no solo por sus logros y su capacidad de motivar, sino también por su habilidad para mantenerse auténtica, conectada con sus propias necesidades y dispuesta a inspirar a otros desde un lugar de equilibrio y bienestar integral. Con este enfoque, el impacto de su liderazgo será aún más profundo, promoviendo un desarrollo no solo en sus propios proyectos, sino también en el bienestar y crecimiento de quienes la rodean.',
        ],
      },
    ],
  },
  en: {
    1: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often take center stage, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build strong and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. What is interesting about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or professional.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach but can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Description of the Emotional Intelligence Profile',
        content: [
          'The evaluated individual shows a profile that, while possessing some basic emotional skills, still needs to develop key competencies to face challenges and manage relationships effectively. At this time, they may encounter difficulties in regulating their own emotions and interpreting those of others, which impacts the quality of their interactions. However, this starting point is an opportunity to work on more conscious and focused growth, with clear objectives and a specific action plan.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-awareness',
            description: '',
            subList: [
              {
                title: 'Area to work on',
                description:
                  'The evaluated individual presents a low level of self-awareness, which implies that they often do not recognize their own emotions or how these influence their behavior. Working on identifying and naming their feelings is the first step towards building stronger self-awareness.',
              },
              {
                title: 'Suggestion',
                description:
                  'Implementing emotional diary exercises, where they note how they feel during different times of the day, will help increase the perception of their emotional states and recognize repetitive patterns.',
              },
            ],
          },
          {
            title: 'Self-management',
            subList: [
              {
                title: 'Area to work on',
                description:
                  'Self-management is limited in this profile, and the individual may experience difficulties in controlling their emotions, especially in situations of pressure or conflict. This could lead to impulsive reactions that affect their environment.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practicing breathing and relaxation techniques before challenging moments will contribute to improving their ability to remain calm and respond in a more controlled manner.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Empathy',
            subList: [
              {
                title: 'Area to work on',
                description:
                  "At this level, empathy is not yet developed, which can lead to problems in understanding other people's perspectives and connecting with their emotions. This could translate into misunderstandings or difficulties in building trusting relationships.",
              },
              {
                title: 'Suggestion',
                description:
                  'Performing "putting oneself in the other\'s shoes" exercises and maintaining an open and non-defensive attitude towards the feelings of others will help strengthen this competency.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Area to work on',
                description:
                  'Social skills are in an initial stage, with limitations in managing conflicts or positively influencing groups. The individual may feel isolated or have difficulties collaborating in a team.',
              },
              {
                title: 'Suggestion',
                description:
                  'Participating in assertive communication activities and support groups can be very helpful in improving their confidence and interpersonal skills.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Area to work on',
                description:
                  'Internal motivation is low, and the individual may depend on external factors to feel driven to achieve their goals. It is important to strengthen intrinsic motivation to maintain a constant focus.',
              },
              {
                title: 'Suggestion',
                description:
                  'Defining small and achievable goals, and rewarding themselves for the achievements obtained, will help generate greater satisfaction and long-term focus.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Build greater self-awareness',
            description:
              'Creating an emotional diary to record experiences and reflect on what triggers certain emotions is a fundamental practice for identifying patterns and learning to anticipate their emotional responses.',
          },
          {
            title: 'Develop emotional resilience',
            description:
              'Participating in activities that promote adaptation to changes, such as role-playing and simulated scenarios, will help the individual learn to better manage their emotions in the face of unforeseen situations.',
          },
          {
            title: 'Improve empathy through active listening',
            description:
              'Performing active listening exercises in controlled environments, where the art of listening without interrupting is practiced, to be able to tune in more easily to the emotions of others.',
          },
          {
            title: 'Foster self-motivation',
            description:
              'Creating a "vision board" with inspiring images and phrases that reflect their short- and long-term personal and professional goals, reviewing it regularly to maintain high motivation.',
          },
          {
            title: 'Increase relationship management skills',
            description:
              'Participating in discussion groups or volunteer teams will help the individual strengthen their ability to connect and collaborate with people with different styles and backgrounds.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential to remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Individual sports',
            description:
              'Activities such as running, swimming, or cycling are recommended to develop self-discipline and the capacity for self-motivation. These sports allow the individual to focus on their own progress and manage stress in a healthy way.',
          },
          {
            title: 'Yoga or Pilates',
            description:
              'Practicing yoga or Pilates is very useful for fostering self-control and emotional regulation. As activities that combine breathing, stretching, and relaxation, they help calm the mind and reduce anxiety, facilitating better stress management.',
          },
          {
            pageBreak: true,
            title: 'Book or film clubs',
            description:
              'Participating in book or film groups can improve the capacity for empathy and active listening by sharing and interpreting different perspectives. Reflecting on characters and their emotions helps to better understand the experiences of others.',
          },
          {
            title: 'Mindfulness practices',
            description:
              'Introducing oneself to the practice of mindfulness or guided meditation allows for the development of self-awareness, as it promotes the observation of emotions and thoughts without judging them. Applying these techniques in daily life contributes to greater emotional stability.',
          },
          {
            title: 'Series',
            description:
              '"The Good Place". This series combines humor and philosophy to explore human nature and emotions. It is ideal for reflecting on empathy, the sense of justice, and personal development.',
          },
          {
            title: 'Podcast',
            description:
              '"Entiende Tu Mente" (Understand Your Mind). This podcast in Spanish addresses topics related to emotional intelligence and psychology, offering simple and everyday strategies to improve self-management and interpersonal relationships. Ideal for working on self-awareness and empathy in a practical way.',
          },
          {
            title: 'Board game',
            description:
              '"Dixit". This game stimulates imagination and the interpretation of emotions through illustrations, allowing for the development of skills such as communication, creativity, and empathy in a playful and relaxed environment.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual has a great opportunity to develop in the area of emotional intelligence. By focusing on strengthening their self-awareness, self-control, and empathy, they will be able to begin to manage their emotions more effectively and build more satisfying and constructive relationships. This is just the beginning of a path of continuous development, and with dedication and perseverance, they will be able to achieve greater emotional balance that will allow them to navigate confidently both personally and professionally.',
        ],
      },
    ],
    2: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often take center stage, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build strong and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. What is interesting about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or professional.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach but can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Description of the Emotional Intelligence Profile',
        content: [
          'The evaluated individual presents a balanced emotional profile, with the ability to recognize and manage their emotions in most situations. Although their self-awareness is adequate, they could still work on better understanding how their internal states affect their decisions. Likewise, they show an intermediate level of empathy and social skills, which allows them to establish functional relationships, although with some difficulty in connecting at a deeper level. This profile indicates that, while the individual has developed a solid foundation of emotional competencies, they could still strengthen their resilience and self-motivation, which would allow them to maintain balance even in times of high stress.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-awareness',
            description: '',
            subList: [
              {
                title: 'Current area',
                description:
                  'The individual shows a good ability to recognize their emotions in most everyday situations, but could benefit from more focused work on identifying how those feelings affect their interactions and decisions.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice emotional monitoring during pressure situations, such as important meetings or moments of conflict, to identify which emotions are activated and how they influence their behavior. Keep a weekly emotional log focusing on specific situations.',
              },
            ],
          },
          {
            title: 'Self-management',
            subList: [
              {
                title: 'Current area',
                description:
                  'The self-management they possess allows them to respond with control in most circumstances. However, they may experience problems when managing intense emotions, such as frustration or anxiety.',
              },
              {
                title: 'Suggestion',
                description:
                  'Incorporate relaxation and breathing techniques before facing challenging tasks or complex decisions. Also, perform a mindful pause before reacting in moments of stress.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Empathy',
            subList: [
              {
                title: 'Current area',
                description:
                  'The evaluated individual shows a level of empathy where they are able to recognize the emotions of others in a general social environment. However, they could still work on connecting more deeply, especially in situations that demand greater emotional understanding.',
              },
              {
                title: 'Suggestion',
                description:
                  "Practice active listening, focusing on understanding both what is said and what is not said (underlying emotions). Perform role-playing exercises to foster the ability to put oneself in another's shoes.",
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current area',
                description:
                  'They present a level of social skills that allows them to interact constructively in formal and informal contexts. However, they may feel limited when it is required to influence a group or lead initiatives.',
              },
              {
                title: 'Suggestion',
                description:
                  'Participate in group activities that involve shared leadership or coordination of small teams to strengthen their capacity for influence and collaboration.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current area',
                description:
                  'The internal motivation they possess allows them the ability to maintain focus on their personal goals. Even so, they could benefit from greater clarity regarding their personal values, to align their goals with a clearer purpose.',
              },
              {
                title: 'Suggestion',
                description:
                  'Perform short- and long-term goal-setting exercises that connect with their fundamental interests and values. Create an "achievement map" to visualize their progress and maintain constant motivation.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Develop self-awareness',
            description:
              'Perform daily meditation practices of 10 to 15 minutes, focused on observing thoughts and emotions without judgment.',
          },
          {
            title: 'Strengthen resilience',
            description:
              'Practice stress management with techniques that include visualization and emotional regulation.',
          },
          {
            title: 'Enhance empathy',
            description:
              "Attend workshops or seminars that address non-verbal communication and understanding others' perspectives.",
          },
          {
            title: 'Expand social skills',
            description:
              'Get involved in networking activities where they must interact with unfamiliar people and build new relationships.',
          },
          {
            title: 'Increase self-motivation',
            description:
              'Define a clear purpose for each goal and create a system of personal rewards upon achieving them.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential to remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Individual sports',
            description:
              'Activities such as tennis, gymnastics, or rock climbing are excellent for developing concentration and personal resilience. These sports require individual focus and constant commitment, which helps improve self-discipline and manage stress in a healthy way.',
          },
          {
            title: 'Outdoor group activities',
            description:
              'Participating in team sports such as soccer, basketball, or volleyball contributes to strengthening social skills and developing greater empathy. Interaction and teamwork allow the individual to learn to communicate better, listen actively, and collaborate effectively.',
          },
          {
            title: 'Yoga or Tai Chi',
            description:
              'Practicing yoga or tai chi is useful for fostering inner balance and emotional regulation. These activities combine breathing, gentle movements, and meditation, helping to reduce anxiety and facilitating better management of stress and intense emotions.',
          },
          {
            pageBreak: true,
            title: 'Reading or debate clubs',
            description:
              'Joining a reading club or debate group is ideal for developing active listening skills and critical thinking. Reflecting on different points of view and sharing experiences can help improve empathy and better understand the perspectives of others.',
          },
          {
            title: 'Mindfulness practices',
            description:
              'Incorporating the practice of mindfulness regularly can strengthen self-awareness and improve the ability to manage emotions. Performing guided meditation or deep breathing exercises for 10 minutes each morning is a good starting point.',
          },
          {
            title: 'Series',
            description:
              '"This Is Us". A series that explores human emotions, family relationships, and personal growth throughout life. It is ideal for reflecting on empathy, conflict management, and the power of forgiveness.',
          },
          {
            title: 'Podcast',
            description:
              '"Psicología para Todos" (Psychology for Everyone). A podcast in Spanish that offers practical and easy-to-apply tools for emotional development and relationship management. Episodes address topics such as self-awareness, empathy, and motivation.',
          },
          {
            title: 'Board game',
            description:
              '"Codenames". A game that combines strategy and communication, ideal for working as a team, refining observation skills, and enhancing empathy by interpreting the clues of other players in a fun and relaxed environment.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual presents a profile that reflects acceptable emotional management and a good foundation for the development of advanced emotional intelligence. By focusing on working on resilience and empathy, they will be able to reach a state of greater emotional stability and become a role model in interpersonal relationship management. This is a solid starting point that, with time and adequate effort, could evolve towards an outstanding level of emotional intelligence.',
        ],
      },
    ],
    3: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often take center stage, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build strong and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. What is interesting about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or professional.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach but can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Description of the Emotional Intelligence Profile',
        content: [
          'The evaluated individual presents an advanced level of empathy and social skills, which allow them to establish trusting relationships and understand the perspectives of others with ease. This ability to attune to the emotions of others creates an environment of support and open communication. However, the "Empathetic" profile could also benefit from working on the management of their own emotions, to avoid absorbing the emotional burdens of others.',
          'The evaluated individual has the ability to adapt to different contexts and to detect the emotional needs of those around them. Even so, they may experience difficulties in separating their own emotions from those of others, which could lead to moments of emotional saturation. With a focus on developing self-management and resilience skills, this person could reach a state of greater balance and emotional well-being.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-awareness',
            description: '',
            subList: [
              {
                title: 'Current area',
                description:
                  'The evaluated individual shows a level of self-awareness where they are able to recognize their emotions in most situations. However, they may have difficulty distinguishing between their own feelings and those of the people they interact with.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice "emotional cleansing" exercises at the end of the day, where they reflect on the emotions experienced and identify which were their own and which were absorbed from others.',
              },
            ],
          },
          {
            title: 'Self-management',
            subList: [
              {
                title: 'Current area',
                description:
                  'The individual can control their responses in most circumstances, but could benefit from learning to handle situations of high emotional load without feeling overwhelmed.',
              },
              {
                pageBreak: true,
                title: 'Suggestion',
                description:
                  'Incorporate progressive relaxation techniques and establish clear emotional boundaries in contexts of high emotional demand (for example, intense conversations or conflict situations).',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current area',
                description:
                  'Their empathy allows them to connect with others and create strong interpersonal relationships. However, they must work on not being completely carried away by the emotions of others.',
              },
              {
                title: 'Suggestion',
                description:
                  'Perform self-reflection exercises and learn to say "no" assertively when they feel that the emotions of other people begin to negatively impact their own emotional state.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current area',
                description:
                  'The evaluated individual can manage conflicts with diplomacy and solve problems in a team effectively. However, they could focus more on assertive decision-making to avoid being overly accommodating.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice assertive leadership techniques and perform group decision-making simulations to strengthen their ability to influence positively without falling into overprotection of others.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current area',
                description:
                  'Their internal motivation drives a strong desire to help and generate a positive impact on the environment. Even so, they could benefit from establishing more balanced goals that consider both their needs and those of the people around them.',
              },
              {
                title: 'Suggestion',
                description:
                  'Define clear personal goals that are not solely focused on others, but reflect a balance between self-care and support for others.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Foster emotional self-care',
            description:
              'Establish disconnection routines at the end of the day to release accumulated tensions and refocus on their own needs.',
          },
          {
            title: 'Establish healthy boundaries',
            description:
              'Learn to say "no" assertively when they perceive that they are becoming emotionally overloaded.',
          },
          {
            title: 'Practice emotional separation',
            description:
              'Implement the "anchoring" technique, where the individual visualizes a symbol or word that reminds them of their own emotional stability, thus avoiding being absorbed by the emotions of others.',
          },
          {
            title: 'Strengthen intrinsic motivation',
            description:
              'Create a list of personal goals that do not depend on the approval or satisfaction of others, but reflect their own goals.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential to remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Individual or partner sports',
            description:
              'Paddle tennis or tennis are ideal for balancing the need for connection with others without losing focus on oneself. These activities help release tensions and maintain a balanced focus between what is their own and what is shared.',
          },
          {
            title: 'Guided meditation practices',
            description:
              'Using apps like Insight Timer or Headspace can be useful for carrying out meditations focused on self-compassion and the strengthening of emotional boundaries.',
          },
          {
            title: 'Discussion and volunteer clubs',
            description:
              'Participating in volunteer activities or thematic discussion clubs (literature, film, philosophy) helps the individual continue connecting with others without losing their own space for reflection and personal growth.',
          },
          {
            pageBreak: true,
            title: 'Series',
            description:
              '"Atypical". A series that explores emotions, autism, and each person\'s ability to understand the world uniquely. Ideal for reflecting on empathy and the management of emotions in everyday situations.',
          },
          {
            title: 'Podcast',
            description:
              '"Emotions Matter". An English-language podcast that addresses different approaches to emotional intelligence, with guests who share tools for managing complex emotional situations and maintaining emotional balance.',
          },
          {
            title: 'Board game',
            description:
              '"The Mind". A cooperative game where players must synchronize without speaking to place cards in the correct order. It is ideal for developing emotional intuition and interpersonal connection.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual shows an innate ability to connect with the emotions of others and build relationships based on understanding and mutual support. These skills allow them to easily detect emotional needs in their environment, acting as a bridge between people and promoting an atmosphere of collaboration and respect. However, this same ability to empathize deeply can lead to moments of emotional overload, especially when they become excessively involved in the problems of others or when they do not establish clear boundaries to protect their own well-being.',
          'The challenge for the evaluated individual is to achieve a balance between providing support to others and preserving their own emotional stability. The key is to strengthen self-management, work on emotional regulation, and learn to disconnect when necessary, without losing the sensitivity that characterizes them. With conscious development in these areas, the evaluated individual can reach a state of greater resilience and emotional clarity, becoming a positive role model in their personal and professional environments.',
          'Over time, by refining their self-care skills and learning to recognize when and how to get emotionally involved, the evaluated individual will be able to maximize their impact in a balanced way. This will not only allow them to maintain their own energy and motivation in the long term but also inspire those around them to be more conscious, compassionate, and emotionally intelligent.',
        ],
      },
    ],
    4: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often capture the attention, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build solid and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. The interesting thing about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or work-related.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach, but it can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals, but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Emotional Intelligence Profile Description',
        content: [
          'The evaluated individual presents a profile characterized by a high capacity for teamwork, a willingness to cooperate, and a desire to foster an environment of mutual support. They tend to prioritize the well-being of the group and create an atmosphere of harmony in which people feel included and valued. This tendency to collaborate can efficiently facilitate problem-solving and the achievement of common goals.',
          'However, the evaluated individual could benefit from working on their assertiveness to avoid falling into a complacent attitude or personal sacrifice for the good of the group. Furthermore, by focusing so much on teamwork, they may experience difficulties in making decisions alone or prioritizing their own needs. With conscious development of self-management and individual decision-making skills, this person could achieve a greater balance between their desire to collaborate and their ability to maintain a personal focus, ensuring a positive impact both at a group and individual level.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-awareness',
            description: '',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual shows a level of self-awareness that allows for a general understanding of their emotions in group settings. However, they may lose connection with their own feelings when the group goes through moments of tension.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice self-assessment at the end of each group interaction, identifying their own emotional states and reflecting on how these influenced their contributions to the group.',
              },
            ],
          },
          {
            title: 'Self-management',
            subList: [
              {
                title: 'Current Area',
                description:
                  'They usually regulate their responses to avoid conflicts, but may become complacent in situations where a firmer approach is required.',
              },
              {
                pageBreak: true,
                title: 'Suggestion',
                description:
                  'Develop emotional regulation techniques, such as positive visualization and setting boundaries, to strengthen their ability to maintain a balanced stance even when the group pushes for quick decisions.',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current Area',
                description:
                  "They have the ability to put themselves in other people's shoes and understand the emotional dynamics of each team member. However, they can sometimes become emotionally overloaded when trying to mediate conflicts or solve other people's problems.",
              },
              {
                title: 'Suggestion',
                description:
                  'Implement the practice of "empathic distancing," where they reflect on when to get deeply involved and when it is better to adopt a more neutral approach to avoid emotional exhaustion.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has a natural ability to interact effectively in groups and foster cooperation among team members. However, they could work on taking a more active leadership role when the situation requires it.',
              },
              {
                title: 'Suggestion',
                description:
                  'Conduct leadership simulations and participate in group projects with rotating roles, which will allow them to gain more confidence in their ability to influence positively without losing the collaborative focus.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current Area',
                description:
                  'Internal motivation is oriented towards group achievement and the creation of a supportive environment. While this drives their desire to collaborate, they could benefit from defining individual goals that also consider their personal interests and ambitions.',
              },
              {
                title: 'Suggestion',
                description:
                  "Perform exercises in setting personal goals that align with their values but do not depend exclusively on the team's success.",
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Strengthen self-confidence',
            description:
              'Engage in activities that promote solo decision-making, such as personal projects or individual leadership situations.',
          },
          {
            title: 'Foster emotional separation',
            description:
              'Practice mindfulness techniques to reflect on when to take an active role and when to remain in an observer role to avoid being overwhelmed by group dynamics.',
          },
          {
            title: 'Increase self-motivation capacity',
            description:
              'Create a system of personal achievements that remains independent of group success, ensuring that individual goals are also prioritized.',
          },
          {
            title: 'Expand influencing capacity',
            description:
              'Participate in negotiation and conflict resolution activities to strengthen the ability to make difficult decisions on behalf of the group.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential to remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Team sports',
            description:
              'Soccer, basketball, or volleyball are ideal for enhancing collaborative skills while working on quick decision-making and managing pressure in a group environment.',
          },
          {
            title: 'Discussion and debate groups',
            description:
              'Joining debate groups is useful for improving the ability to express their ideas clearly while maintaining respect and consideration for the opinions of others.',
          },
          {
            title: 'Mindfulness practices',
            description:
              'Using mindfulness apps like Headspace or Calm can help the individual reconnect with themselves after long days of group interaction.',
          },
          {
            pageBreak: true,
            title: 'Series',
            description:
              '"Brooklyn Nine-Nine". A series that humorously addresses group dynamics, collaborative work, and shared leadership, ideal for reflecting on how emotions are managed within a team.',
          },
          {
            title: 'Podcast',
            description:
              '"The Team Building Show". A podcast that explores techniques and strategies for building cohesive teams, with episodes addressing topics such as effective communication, conflict resolution, and group motivation.',
          },
          {
            title: 'Board game',
            description:
              '"Pandemic". A cooperative game where players must work together to save the world from a global epidemic. Ideal for developing communication, planning, and team decision-making skills.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          "The evaluated individual shows a great capacity to foster collaboration and mutual support in a group environment, acting as a point of reference for teamwork. With their ability to generate cohesion and their willingness to help, they tend to prioritize the group's success over their own. However, it is essential that they also focus on developing their self-management and defining clear personal goals to avoid complacency and maintain a balance between their individual well-being and that of the team.",
          'By working on their assertiveness and strengthening their ability to make decisions independently, the evaluated individual will be able to maximize their impact in a balanced way, ensuring that their collaborative approach does not lead to unnecessary sacrifices. Over time, they can become a leader who inspires others to collaborate with empathy and effectiveness, creating a harmonious and successful work environment for everyone.',
        ],
      },
    ],
    5: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often capture the attention, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build solid and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. The interesting thing about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or work-related.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach, but it can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals, but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Emotional Intelligence Profile Description',
        content: [
          'The evaluated individual presents an advanced level of self-awareness, which allows them to easily identify and understand their own emotions, as well as reflect on how these affect their behavior and decisions. This level of self-knowledge provides a solid foundation for emotional management and conscious decision-making, resulting in clear and effective interpersonal interactions.',
          'However, the evaluated individual could benefit from working on their emotional flexibility, as an excessively introspective approach could lead them to focus too much on their own emotional states and lose sight of the needs and emotions of others. At times, this tendency can hinder adaptation to unexpected changes or to contexts that require a more spontaneous and less analytical approach. With focused development in emotional regulation and broadening their perspective towards the environment, the evaluated individual will be able to reach an even greater level of emotional intelligence, managing not only their own emotions but also connecting more deeply with those around them.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-awareness',
            description: '',
            subList: [
              {
                title: 'Current Area',
                description:
                  'They have a great ability to recognize their emotions and understand their causes, which allows them to reflect on their actions and maintain a high level of positive self-criticism.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice self-compassion, especially in moments of excessive self-criticism. Engaging in mindfulness exercises focused on accepting their emotions without immediately evaluating them can be very helpful.',
              },
            ],
          },
          {
            title: 'Self-management',
            subList: [
              {
                pageBreak: true,
                title: 'Current Area',
                description:
                  'The evaluated individual shows a good capacity for self-management in most situations but may experience difficulties in remaining flexible in contexts of high pressure or uncertainty.',
              },
              {
                title: 'Suggestion',
                description:
                  'Implement emotional adaptation techniques, such as visualizing possible outcomes and creating alternative plans, to develop greater resilience to unforeseen changes.',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current Area',
                description:
                  'While the evaluated individual has an adequate level of empathy, their strong focus on introspection could lead them to concentrate more on their own emotions and occasionally overlook the emotional cues from their environment.',
              },
              {
                title: 'Suggestion',
                description:
                  "Practice active listening exercises, focusing on interpreting non-verbal language and the emotional nuances of others, to balance their internal perception with a more complete understanding of others' emotions.",
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The social skills they possess are adequate, especially in environments where deep conversations and mutual understanding are valued. However, the evaluated individual could work on situations that require a quick and spontaneous response.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice improvisation in controlled situations, such as role-playing or interaction simulations where they must react without prior analysis, to foster greater emotional and communication agility.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current Area',
                description:
                  'Internal motivation is solid and driven by a strong desire for personal growth and self-discovery. Even so, the evaluated individual could benefit from defining goals that focus on their environment and how their personal development can positively impact others.',
              },
              {
                title: 'Suggestion',
                description:
                  'Develop a development plan that combines personal goals with relational goals, so that their motivation encompasses both internal growth and external impact.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Foster emotional flexibility',
            description:
              'Develop the ability to adapt to different contexts through "adaptive mindfulness" exercises, where acceptance of changes is practiced and reflection on how to respond positively is encouraged.',
          },
          {
            title: 'Strengthen interpersonal connection',
            description:
              'Participate in active listening and reflective empathy activities, such as non-verbal communication workshops and role-playing exercises to broaden emotional perception towards the environment.',
          },
          {
            title: 'Increase emotional agility',
            description:
              'Engage in improvisation exercises and participate in group dynamics that involve quick and spontaneous responses to step out of the comfort zone of continuous analysis.',
          },
          {
            title: 'Integrate personal and relational goals',
            description:
              'Define goals that include a balance between self-development and a positive impact on the people they interact with.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential to remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Individual and team sports',
            description:
              'Tennis, climbing, or indoor soccer can help the individual develop the ability to make quick decisions while managing their own emotions. These activities allow combining introspection with the need for immediate action and reaction.',
          },
          {
            title: 'Debate clubs or philosophical discussions',
            description:
              'Joining debate groups is ideal for improving the ability to respond agilely and spontaneously to opposing ideas. This helps to move away from a purely introspective approach and to practice active listening in challenging environments.',
          },
          {
            pageBreak: true,
            title: 'Adaptive mindful meditation practices',
            description:
              'Using adaptive meditations that focus on accepting changes in the environment or in emotions can help the evaluated individual improve their adaptability and better manage unexpected situations.',
          },
          {
            title: 'Series',
            description:
              '"The Crown". A series that explores personal development and the management of emotions in contexts of great responsibility and pressure. Ideal for reflecting on self-management and decision-making in critical moments.',
          },
          {
            title: 'Podcast',
            description:
              '"Hidden Brain". A podcast that explores how the mind and emotions affect decisions. Episodes address topics such as self-awareness, decision-making, and emotional adaptation, providing practical tools for personal development.',
          },
          {
            title: 'Board game',
            description:
              '"Dixit". A game that stimulates the interpretation of emotions through illustrations and metaphors. Ideal for fostering emotional flexibility and the ability to see different perspectives without getting stuck in a single point of view.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual demonstrates a high level of self-awareness, which allows them to clearly identify their emotions and reflect on how these influence their decisions and relationships. This capacity for introspection gives them an advantage in recognizing their own behavior patterns, which facilitates the development of strategies to manage themselves effectively in different situations.',
          'However, due to their analytical focus and tendency to reflect deeply, it is possible that at times they may lose sight of the emotional cues from the environment or be less flexible in the face of unforeseen changes. The main challenge is to balance their desire for self-understanding with greater openness and adaptation to their surroundings, so that they do not feel trapped in a cycle of constant self-evaluation that may limit their ability to act spontaneously and fluidly.',
          'For more comprehensive development, it is important for the evaluated individual to work on their emotional flexibility and strengthen their connection with the emotions of others. Learning to let go of control when necessary and accept their own emotions without the need for excessive analysis will allow them to maintain a healthy balance between internal reflection and external action.',
          'With a focus on these areas, the evaluated individual will be able to integrate their self-awareness with greater empathy and openness towards others, allowing them to make more balanced decisions and react more agilely and effectively to unexpected situations. This will not only benefit their personal development but will also allow them to positively impact their environment, contributing with their emotional clarity and ability to adapt to the needs of the moment.',
        ],
      },
    ],
    6: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often capture the attention, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build solid and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. The interesting thing about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or work-related.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach, but it can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals, but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Emotional Intelligence Profile Description',
        content: [
          'The evaluated individual presents an advanced level of self-management and emotional regulation. This means they have the ability to remain calm and in control in most situations, even those involving high pressure or conflict. Their approach is balanced, and they typically manage their emotions effectively, responding with clarity and serenity rather than reacting impulsively. This competence allows them to face challenges with a proactive attitude and solve problems with greater clarity and efficiency.',
          'However, due to their strong tendency towards emotional control, the evaluated individual may experience difficulties in freely expressing their emotions in situations where greater spontaneity or openness is required. At times, their desire to maintain composure can lead them to suppress feelings that need to be communicated, which could generate internal tensions or a perception of rigidity in their interpersonal relationships. With conscious development in emotional expression and in building a safe space to share their feelings more openly, the evaluated individual will be able to reach a state of greater balance, combining their high capacity for regulation with a deeper and more authentic connection with their environment.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-awareness',
            description: '',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has a level of self-awareness that allows them to identify when an emotion arises and how it might influence their behavior. However, at times they might not give their feelings enough space to manifest.',
              },
              {
                title: 'Suggestion',
                description:
                  'Engage in self-observation exercises focused on emotional expression. Identify moments when they repress or moderate their emotions and ask themselves what the most balanced way to express them would be without losing their self-management.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Self-management',
            subList: [
              {
                title: 'Current Area',
                description:
                  'They possess significant control over their emotional reactions, allowing them to handle conflicts with serenity and solve problems effectively. However, they may become too self-demanding when faced with high-pressure situations.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice relaxation exercises and take intentional pauses to reduce internal tension. Introduce disconnection activities, such as walks or conscious breathing exercises, to avoid burnout from excessive regulation.',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has a level of empathy where they are able to understand how their responses impact others. However, they could work on showing their emotional side more openly to generate a more authentic connection.',
              },
              {
                title: 'Suggestion',
                description:
                  'Engage in emotional openness exercises, such as practicing sharing personal experiences in safe environments, to strengthen empathy through greater emotional transparency.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has good social skills and tends to be perceived as a stable and reliable person in work environments and their close circle. However, their self-control could be interpreted as detachment in situations that require greater emotional expression.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice emotional communication techniques and participate in discussion groups where openness and the exchange of feelings are encouraged, to balance their stability with a more visible expression of their emotions.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The internal motivation of the evaluated individual is oriented towards achievement and personal improvement. They usually maintain a high level of energy and perseverance but could benefit from focusing on goals that also include the development of their emotional side.',
              },
              {
                title: 'Suggestion',
                description:
                  'Define goals that not only focus on managing their emotions but also on developing emotional openness and acceptance, seeking a balance between control and expression.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Foster healthy emotional expression',
            description:
              'Develop the ability to express emotions clearly and directly through assertive communication techniques and emotional writing exercises.',
          },
          {
            title: 'Work on emotional flexibility',
            description:
              'Practice activities such as role-playing or improvisation, where they must quickly adapt to changes in emotional context, to break the tendency towards rigidity.',
          },
          {
            title: 'Create a space for openness',
            description:
              'Participate in support groups or activities where emotional openness and trust are encouraged, to strengthen the ability to share their feelings safely.',
          },
          {
            title: 'Strengthen interpersonal connection',
            description:
              'Engage in group dynamics or volunteer activities that require the creation of an emotional bond with others, balancing regulation with greater empathic connection.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential to remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Sports that combine self-control and expression',
            description:
              'Yoga, boxing, or tai chi are ideal for balancing control and emotional release. These activities help the individual maintain their internal stability while allowing for greater expression through movement.',
          },
          {
            pageBreak: true,
            title: 'Emotional writing practices',
            description:
              'Writing in an emotional journal or doing free writing exercises can help the evaluated individual explore and express feelings they usually keep under control. Reflecting on their emotions through writing can be an effective way to release accumulated emotional tension.',
          },
          {
            title: 'Creative expression clubs',
            description:
              'Joining theater groups, art workshops, or improvisation classes is ideal for working on emotional openness and flexibility in a safe and guided environment, allowing the individual to explore new ways of expressing their emotions.',
          },
          {
            title: 'Series',
            description:
              '"This Is Us". A series that explores human emotions deeply and honestly. Ideal for reflecting on the importance of emotional expression and how family dynamics impact emotional regulation.',
          },
          {
            title: 'Podcast',
            description:
              '"The Science of Happiness". A podcast that addresses science-based strategies for maintaining emotional balance, with episodes focused on how to manage emotions and develop overall well-being.',
          },
          {
            title: 'Board game',
            description:
              '"Codenames". A game that combines strategy and communication, ideal for teamwork and practicing patience and clarity in expression while maintaining control without losing spontaneity.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual possesses a great ability to manage their emotions effectively, remaining calm and in control even in high-pressure situations. This skill allows them to make clear and balanced decisions, making them a reference point for stability and reliability in their environment. Thanks to their self-management ability, they typically face challenges with serenity and act proactively to solve problems without being carried away by impulses or negative emotional reactions.',
          'However, the strong emotional control they exert can also lead them to repress their own feelings or appear too reserved in situations that require greater emotional expression and authenticity. This tendency to always maintain composure could hinder the creation of deeper and closer relationships, as others may perceive them as distant or inaccessible in contexts that require greater emotional openness.',
          'To achieve more complete emotional development, it is important for the evaluated individual to work on finding a balance between regulation and expression. Learning to communicate their emotions more openly and show their vulnerable side in a safe environment will allow them to strengthen their interpersonal relationships and create a space of greater mutual trust. The key is to accept that showing their feelings is not a sign of weakness but a way to connect authentically with others.',
          'Over time, by integrating their capacity for regulation with freer and more sincere emotional expression, the evaluated individual will be able to achieve a deeper balance and become a model not only of stability but also of openness and closeness. This will not only benefit their personal development but will also allow them to positively influence their environment, creating an atmosphere where self-control and emotional expression coexist harmoniously, promoting relationships based on trust, respect, and empathy.',
        ],
      },
    ],
    7: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often take center stage, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build solid and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. The interesting thing about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or professional.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach, but it can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals, but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Description of the Emotional Intelligence Profile',
        content: [
          'The evaluated individual presents a high level of internal motivation, which means they are driven by goals and objectives that go beyond external factors. Their ability to self-motivate and stay focused allows them to approach projects with enthusiasm and persistence, showing a strong desire to achieve positive results. This constant energy gives them an additional boost to face challenges and surpass themselves, making them someone achievement-oriented with a spirit of self-improvement.',
          'However, this level of motivation could sometimes lead the evaluated individual to prioritize the fulfillment of their objectives over their personal well-being, especially when under pressure. Furthermore, their constant drive to achieve new goals could make it difficult for them to enjoy the process and disconnect adequately, creating a risk of burnout or demotivation when things do not go as planned. To achieve a healthier balance, the evaluated individual could benefit from working on their ability to manage frustration and learn to enjoy the small achievements along the way to their main objectives. With a focus on developing greater self-care and a more flexible perspective, they will be able to maintain their high level of motivation without compromising their emotional well-being.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-Awareness',
            description: '',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual shows a good ability to recognize their own goals and what drives them to achieve them. However, they could benefit from additional work to identify when their motivation begins to cross the line into self-demandingness.',
              },
              {
                title: 'Suggestion',
                description:
                  'Incorporate reflection exercises at the end of each week to evaluate what achievements have been obtained and what learnings have been generated, allowing themselves to celebrate small victories and not just big results.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Self-Management',
            subList: [
              {
                title: 'Current Area',
                description:
                  'Self-management is solid, allowing the individual to stay focused on their goals and manage their emotions based on what they need to achieve. However, they could work on being more flexible with goals and learning to adjust to changes without this affecting their motivation.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice creating alternative plans (Plan B and C) when designing their objectives, to develop greater resilience and acceptance when setbacks occur.',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current Area',
                description:
                  'While the evaluated individual has the ability to empathize with those around them, their strong achievement orientation could lead them to focus more on their own goals than on the emotional needs of others.',
              },
              {
                title: 'Suggestion',
                description:
                  'Conduct "empathy review" exercises where, after each project or group interaction, they reflect on the emotional impact it had on others and how they could better balance their goals with those of their environment.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual possesses good social skills and tends to be perceived as someone with great energy and enthusiasm, capable of inspiring others with their spirit of self-improvement. However, they could work on being more patient and understanding when others do not share the same level of motivation.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice active listening in team contexts, allowing others to share their points of view without interrupting, to develop a greater capacity for containment and understanding towards different perspectives.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current Area',
                description:
                  'They feel a constant energy and an innate desire to achieve their goals and develop continuously. However, this high level of motivation could also become a double-edged sword if it is not accompanied by a balance between achievement and enjoyment.',
              },
              {
                title: 'Suggestion',
                description:
                  'Incorporate scheduled rest periods and celebrate each advancement as a success in itself, to maintain motivation without generating long-term exhaustion.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Foster emotional flexibility',
            description:
              'Learn to adapt their goals and expectations when circumstances change, without this negatively affecting their motivation.',
          },
          {
            title: 'Develop self-compassion',
            description:
              'Incorporate self-compassion practices to avoid excessive self-demandingness, especially in moments of frustration or when goals are not achieved on the first try.',
          },
          {
            title: 'Create a balance between achievement and well-being',
            description:
              'Define specific moments of disconnection and rest during the week to enjoy other activities that are not related to their main objectives.',
          },
          {
            title: 'Strengthen interpersonal connection',
            description:
              'Participate in group activities where the collaborative process is valued more than the final result, to develop a greater connection with their environment.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential that they remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Sports that involve goals and personal improvement',
            description:
              'Running, CrossFit, or triathlon are ideal for maintaining focus on personal growth objectives and constantly measuring progress. However, it is important to accompany these sports with relaxation activities to avoid exhaustion.',
          },
          {
            pageBreak: true,
            title: 'Team activities with a focus on processes',
            description:
              'Participating in recreational sports teams (e.g., volleyball or amateur soccer) where the main objective is not to win, but to enjoy the process, will help the evaluated individual maintain a balance between motivation and enjoyment.',
          },
          {
            title: 'Mindfulness practices focused on the here and now',
            description:
              'Introduce the practice of mindfulness to focus on the present without losing sight of long-term goals. Applications like Headspace or Calm can be useful for creating a mindfulness routine that fosters emotional balance.',
          },
          {
            title: 'Series',
            description:
              '"Chef\'s Table". A series that explores the motivation and passion of world-renowned chefs. Ideal for reflecting on the creative process and how effort, motivation, and personal well-being are combined to achieve excellence.',
          },
          {
            title: 'Podcast',
            description:
              '"The Tim Ferriss Show". A podcast that addresses motivation, productivity, and personal development, with interviews with high-performing individuals who share their strategies for staying motivated and balanced.',
          },
          {
            title: 'Board game',
            description:
              '"Azul". A strategic game that requires planning and precision to complete patterns. It is ideal for working on patience, focus, and emotional flexibility when goals are not achieved immediately.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual shows a high level of internal motivation, which allows them to face challenges with energy and persistence, maintaining a constant focus on their goals. Their desire to achieve objectives and surpass themselves drives a spirit of continuous growth and development, making them someone with a great capacity to inspire those around them. Furthermore, this strong achievement orientation gives them a significant advantage in competitive contexts and allows them to maintain a positive attitude even in the face of obstacles and difficulties.',
          'However, this high level of motivation also entails certain challenges. The evaluated individual may at times prioritize their goals over their personal well-being, or even feel constant pressure to perform at their best, which could lead to excessive self-demandingness or burnout. The key to achieving balanced emotional development lies in learning to accept that rest and disconnection are also part of the path to success and that not all progress is measured in terms of productivity or immediate results.',
          'The challenge for the evaluated individual is to find a balance where their motivation is not affected by setbacks and where the process of achieving goals is as satisfying as the achievement itself. By integrating moments of reflection and self-care, they will be able to learn to enjoy the journey, celebrating each small step as a victory in itself. This integration will allow them to maintain their high energy and constant motivation without compromising their emotional well-being, ensuring sustainable long-term progress.',
          'Over time, by refining their ability to balance the drive for achievement with a greater enjoyment of the present, the evaluated individual will be able to become a role model for healthy motivation and integral well-being. They will not only achieve their goals in a more conscious and fulfilling way, but will also inspire others to seek a balanced approach, demonstrating that true motivation is not based on the constant pursuit of results, but on the ability to maintain passion and energy throughout the entire journey.',
        ],
      },
    ],
    8: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often take center stage, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build solid and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. The interesting thing about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or professional.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach, but it can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals, but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Description of the Emotional Intelligence Profile',
        content: [
          'The evaluated individual presents a highly strategic profile, with an advanced capacity to plan and organize both their emotions and actions in a way that aligns with their long-term goals. They are usually a person with great vision and focus, which allows them to anticipate potential obstacles and adapt quickly to changes. This ability enables them to respond in a balanced and logical way to complex situations, approaching them with an analytical and problem-solving mindset.',
          'However, this strong strategic orientation can also lead the evaluated individual to focus excessively on results and lose sight of the importance of the process and interpersonal relationships on the way to their goals. Furthermore, their focus on planning and efficiency could sometimes make them appear less flexible in situations that require improvisation or spontaneity. To achieve a more balanced development, the evaluated individual could benefit from working on being more open to uncertainty and accepting that not everything can be foreseen or planned. Learning to adapt to unexpected situations with greater emotional openness and to value experiences in the present will allow them not only to achieve their goals but also to enjoy the journey more.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-Awareness',
            description: '',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual shows a level of self-awareness where they can identify their emotions and understand how these influence their strategic decisions. However, they could work on recognizing when their analytical approach begins to limit their openness to new experiences.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice self-observation during moments of improvisation or unexpected changes, identifying how their mind seeks to control the situation and exploring ways to accept uncertainty with greater flexibility.',
              },
            ],
          },
          {
            title: 'Self-Management',
            subList: [
              {
                pageBreak: true,
                title: 'Current Area',
                description:
                  'They possess a great capacity to regulate their emotions and stay focused on their goals, even in high-pressure situations. However, they could benefit from learning to incorporate moments of relaxation and rest to avoid excessive planning that generates rigidity.',
              },
              {
                title: 'Suggestion',
                description:
                  'Establish specific moments of disconnection in their daily routine, where they can allow themselves to act spontaneously without a predetermined plan, to balance structure with flexibility.',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual is capable of understanding the emotions of others and anticipating how their actions impact the environment. However, they could work on showing greater emotional openness and authenticity to build closer relationships that are not solely based on shared objectives.',
              },
              {
                title: 'Suggestion',
                description:
                  'Participate in activities that foster emotional expression, such as effective communication workshops and discussion groups focused on personal connection, to balance their logical approach with greater emotional sensitivity.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has good social skills, with a great capacity to positively influence others through clear and focused communication. However, their focus on efficiency and achieving objectives could be interpreted as coldness or distance in certain contexts.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice emotional communication techniques, where the focus is not on the final result but on sharing experiences and feelings in a more open and relaxed way, to strengthen their personal relationships.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The internal motivation of the evaluated individual is oriented towards achieving significant goals. However, they could benefit from working on goals that not only focus on personal success but also on developing a balance between their professional and personal life.',
              },
              {
                title: 'Suggestion',
                description:
                  'Define short-term goals that include enjoying activities unrelated to their strategic development, to maintain a more balanced and sustainable motivation in the long term.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Foster openness to uncertainty',
            description:
              'Learn to accept that not everything can be planned, allowing themselves to be more flexible and open to the unexpected. Practicing making quick decisions in situations where they do not have complete control will help strengthen this area.',
          },
          {
            title: 'Work on emotional expression',
            description:
              'Participate in activities that require sharing personal experiences and emotions without a predetermined objective, such as creativity workshops or emotional writing.',
          },
          {
            title: 'Develop a more holistic perspective',
            description:
              'Encourage the enjoyment of the process and not just the final result. Engaging in recreational activities that do not involve strict planning will help clear the mind and reduce rigidity.',
          },
          {
            title: 'Strengthen interpersonal relationships',
            description:
              'Get involved in group dynamics that focus more on emotional connection than on achieving goals, to balance the strategic approach with greater interpersonal openness.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential that they remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Sports of strategy and spontaneity',
            description:
              'Chess, badminton, or paintball are ideal for developing the capacity for anticipation and strategy. However, it is recommended to combine them with rapid and spontaneous reaction activities, such as paddle tennis or baseball, to foster adaptability.',
          },
          {
            pageBreak: true,
            title: 'Theatrical improvisation practices',
            description:
              'Participating in improvisation theater workshops is an excellent way to work on emotional flexibility and the ability to respond quickly without a prior plan.',
          },
          {
            title: 'Creative activities without a defined structure',
            description:
              'Engaging in free painting workshops, dance classes, or unscripted photography can help the evaluated individual step out of their comfort zone and explore new forms of expression without the need for a specific outcome.',
          },
          {
            title: 'Series',
            description:
              '"Billions". A series that explores the complexity of strategic decision-making and the emotional impact these have on personal and professional relationships. Ideal for reflecting on how a strategic approach affects life in general.',
          },
          {
            title: 'Podcast',
            description:
              '"Freakonomics Radio". A podcast that explores the hidden side of decision-making and how strategies influence different aspects of life. Ideal for maintaining interest in strategy while fostering a broader perspective.',
          },
          {
            title: 'Board game',
            description:
              '"Risk". A classic strategy and conquest game that requires careful planning and flexibility to adapt to the movements of other players. Ideal for combining strategic thinking with adaptability.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual demonstrates a high level of strategic and planning skills, which allows them to anticipate challenges and design clear and effective solutions. Thanks to their analytical capacity, they can make informed decisions and maintain a results-oriented focus, even in complex environments. This makes them a reference point for managing projects in a structured way, ensuring that each step is aligned with a clear objective.',
          'However, their strong orientation towards strategy and efficiency can sometimes lead them to prioritize results over interpersonal relationships or the enjoyment of the process. It is essential that they work on developing greater flexibility and openness to the unexpected, learning to value both the journey and the destination. By integrating their planning ability with greater sensitivity towards the present, the evaluated individual will be able to achieve a healthier and more effective balance in their decisions.',
          'By finding this balance, they will not only be able to maintain their high performance but will also become a leadership reference that inspires others to combine strategic clarity with a deeper and more authentic connection with their environment. In this way, the evaluated individual will achieve a positive impact that goes beyond individual success, generating interpersonal relationships based on trust and respect.',
        ],
      },
    ],
    9: [
      {
        title: 'Introduction',
        content: [
          "In an increasingly competitive world, where technical skills and academic knowledge often take center stage, emotional intelligence has emerged as a key factor that differentiates individuals in their personal and professional success. Beyond what can be learned in books or courses, emotional intelligence is what allows people to manage their emotions, understand those of others, and build solid and effective interpersonal relationships. This concept, popularized by psychologist Daniel Goleman, encompasses a series of competencies that include the ability to recognize, understand, and manage one's own emotions, as well as positively influence the emotions of others. The interesting thing about emotional intelligence is that, unlike some innate abilities, it can be developed and refined over time, making it an invaluable resource in any context, whether personal or professional.",
          'Nawaiam not only focuses on evaluating behaviors and skills through its innovative gamification approach, but it can also be a powerful tool to help people discover and develop their emotional intelligence. Through our video game, each person has the opportunity to reflect on how they manage their emotions, how they relate to their environment, and how they can improve in these areas to reach their full potential. From stress management to effective decision-making and the creation of more harmonious work environments, emotional intelligence is the catalyst that drives both individual and collective growth. At Nawaiam, we believe that self-awareness and emotional development not only create better professionals, but also more conscious, empathetic, and resilient individuals.',
        ],
      },
      {
        title: 'Description of the Emotional Intelligence Profile',
        content: [
          'The evaluated individual presents an Inspirational Leader profile, characterized by their ability to motivate, guide, and generate a positive impact on others through their actions and words. They often stand out for their ability to transmit their vision with enthusiasm and conviction, which allows them to create an environment of motivation and trust where others feel inspired to follow their example. This combination of internal motivation and advanced social skills gives them significant influence, allowing them to connect with people authentically and empathetically.',
          'However, the evaluated individual might also face challenges related to managing their own expectations and the tendency to assume a constant support role for others. This inclination towards inspiration and leadership could lead them to prioritize the needs of others over their own, running the risk of emotional exhaustion or not allowing themselves enough time to reflect on their own well-being. To achieve a more balanced development, it is essential that the evaluated individual works on self-management and establishing healthy boundaries, ensuring that their motivation to support and inspire does not become a burden. By finding a balance between their drive to lead and their self-care, they will be able to continue inspiring those around them without compromising their own well-being.',
        ],
      },
      {
        title: 'Emotional Competencies',
        content: [],
        list: [
          {
            title: 'Self-Awareness',
            description: '',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has a level of self-awareness that allows them to identify their emotions clearly and understand how these influence their leadership style. However, they could benefit from deeper work in identifying their personal limits.',
              },
              {
                title: 'Suggestion',
                description:
                  'Practice self-evaluation at the end of each day to identify which emotions were generated during the day and which situations could have been managed with a greater balance between supporting others and self-care.',
              },
            ],
          },
          {
            title: 'Self-Management',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has a great capacity to manage their emotional responses and stay focused on their goals, even in high-pressure environments. However, they could work on creating specific moments of disconnection to avoid burnout from their high level of commitment.',
              },
              {
                title: 'Suggestion',
                description:
                  'Incorporate planned breaks into their routine and relaxation activities that allow them to renew their energy without feeling guilty for not always being available to others.',
              },
            ],
          },
          {
            title: 'Empathy',
            subList: [
              {
                title: 'Current Area',
                description:
                  "Empathy is one of the evaluated individual's strongest points, allowing them to connect authentically with others and understand their needs. However, they could work on balancing their desire to help with the ability to stand firm in their own decisions.",
              },
              {
                title: 'Suggestion',
                description:
                  'Practice active listening without assuming the role of "solver" of all problems, allowing others to develop their own autonomy as well.',
              },
            ],
          },
          {
            title: 'Social Skills',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The evaluated individual has excellent social skills, being perceived as a figure of support and guidance for those around them. Their ability to convey messages effectively and motivate others is remarkable, but they could benefit from focusing more on delegating responsibilities to avoid taking on the entire weight of leadership.',
              },
              {
                title: 'Suggestion',
                description:
                  'Carry out delegation exercises in work groups or personal projects, occasionally ceding leadership to foster self-management within the team.',
              },
            ],
          },
          {
            title: 'Internal Motivation',
            subList: [
              {
                title: 'Current Area',
                description:
                  'The internal motivation of the evaluated individual is exceptional, driven by a genuine desire to achieve their goals and help others achieve theirs. However, this level of motivation can lead them to ignore signs of exhaustion.',
              },
              {
                title: 'Suggestion',
                description:
                  'Define self-care goals as part of their development plan, ensuring that their motivation does not only translate into external achievements but also into personal well-being.',
              },
            ],
          },
        ],
      },
      {
        title: 'Guidance, Support, and Recommendations',
        content: [
          'In this section, we will discuss how the evaluated individual can continue to develop through some practical recommendations. We will explore both specific strategies to enhance their emotional competencies and complementary activities, such as sports, entertainment, and learning resources.',
        ],
        list: [
          {
            title: 'Foster self-care',
            description:
              'Establish self-care routines that include both recreational activities and moments of personal reflection to avoid emotional exhaustion.',
          },
          {
            title: 'Work on delegating responsibilities',
            description:
              'Learn to delegate tasks effectively, allowing others to assume leadership roles under their guidance and support.',
          },
          {
            title: 'Strengthen emotional autonomy',
            description:
              'Establish clear boundaries and remember that taking care of oneself is part of leadership, ensuring that their desire to support does not become an excessive burden.',
          },
          {
            title: 'Balance the desire to help with the ability to say "no"',
            description:
              'Practice assertiveness techniques to express when they need time for themselves, without losing their spirit of support and leadership.',
          },
        ],
      },
      {
        title: 'Additional Recommendations',
        content: [
          'To complement the development of their emotional competencies, it is essential that they remain active both physically and mentally. Here are some suggestions that can enhance their skills:',
        ],
        list: [
          {
            title: 'Sports that combine leadership and collaboration',
            description:
              'Activities such as soccer, basketball, or team rowing allow the individual to exercise their leadership skills in an environment where success depends on collaboration. These activities help balance internal motivation with the ability to trust others to achieve joint goals.',
          },
          {
            title: 'Active relaxation practices',
            description:
              'Yoga or tai chi are ideal for maintaining a focus on physical and mental well-being, while also allowing space for self-reflection and energy renewal.',
          },
          {
            pageBreak: true,
            title: 'Guided volunteer activities',
            description:
              'Participating in volunteer projects where they can guide others without taking on the entire weight of leadership is ideal for balancing their desire to help with the ability to delegate and foster the autonomy of others.',
          },
          {
            title: 'Series',
            description:
              '"The West Wing". A series that explores leadership, decision-making, and the impact a leader has on their environment. Ideal for reflecting on how to balance internal motivation with self-care and managing expectations.',
          },
          {
            title: 'Podcast',
            description:
              '"HBR IdeaCast". A podcast that addresses topics of leadership, motivation, and personal balance, with practical tools to improve the ability to positively influence without compromising one\'s own well-being.',
          },
          {
            title: 'Board game',
            description:
              '"Pandemic: Legacy". A cooperative game where the team must work together to overcome global challenges. Ideal for practicing collaborative decision-making and strengthening the ability to delegate responsibilities.',
          },
        ],
      },
      {
        title: 'Conclusion',
        content: [
          'The evaluated individual shows an exceptional level of leadership and motivation skills, making them a natural role model for those around them. Their ability to guide others with enthusiasm, convey their vision clearly, and create a supportive and trusting environment gives them a high level of positive influence in any context. This combination of internal motivation and advanced social skills not only drives their own growth but also creates a profound impact on those who follow them, motivating them to achieve their own goals and develop their potential.',
          'However, their strong desire to support and guide others can lead them to take on additional responsibilities or prioritize the needs of their environment over their own, creating a risk of emotional exhaustion or demotivation when they feel they cannot meet the expectations they impose on themselves. This constant drive to be a source of inspiration and support could, at times, cause the evaluated individual to neglect their own well-being and feel trapped in a cycle of self-demandingness and lack of personal time.',
          'To maintain their leadership capacity in the long term, it is important for the evaluated individual to learn to establish healthy boundaries and balance their support role with dedicated space for self-care and personal reflection. Learning to delegate responsibilities, allowing others to also assume leadership roles, and accepting that they do not always have to be the primary source of motivation can help them reduce the emotional burden they feel and preserve their energy for truly crucial moments.',
          'Over time, by refining their ability to balance their internal motivation with self-care, the evaluated individual will be able to become a model of sustainable and balanced leadership. They will not only be able to continue inspiring others with their vision and example but also demonstrate that true leadership is based on knowing when to guide and when to step back to allow others to grow. This approach will not only allow them to maintain a high level of energy and commitment but will also contribute to creating an environment in which everyone feels empowered and motivated to contribute.',
          'Ultimately, the evaluated individual will be able to continue positively influencing their environment, not only for their achievements and their ability to motivate, but also for their ability to remain authentic, connected with their own needs, and willing to inspire others from a place of balance and integral well-being. With this approach, the impact of their leadership will be even deeper, promoting development not only in their own projects but also in the well-being and growth of those around them.',
        ],
      },
    ],
  },
  pt: {
    1: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relacionamentos interpessoais sólidos e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada demonstra um perfil que, embora possua algumas habilidades emocionais básicas, ainda precisa desenvolver competências chave para enfrentar desafios e gerir relacionamentos de forma eficaz. Neste momento, poderá encontrar dificuldades em regular as suas próprias emoções e em interpretar as dos outros, o que impacta na qualidade das suas interações. No entanto, este ponto de partida é uma oportunidade para trabalhar num crescimento mais consciente e focado, com objetivos claros e um plano de ação específico.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área a trabalhar',
                description:
                  'A pessoa avaliada apresenta um baixo nível de autoconsciência, o que implica que muitas vezes não reconhece as suas próprias emoções ou como estas influenciam o seu comportamento. Trabalhar na identificação e nomeação dos seus sentimentos é o primeiro passo para construir uma autoconsciência mais forte.',
              },
              {
                title: 'Sugestão',
                description:
                  'Implementar exercícios de diário emocional, onde anote como se sente durante diferentes momentos do dia, ajudará a aumentar a perceção dos seus estados emocionais e a reconhecer padrões repetitivos.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área a trabalhar',
                description:
                  'A autogestão é limitada neste perfil, e a pessoa poderá sentir dificuldades em controlar as suas emoções, especialmente em situações de pressão ou conflito. Isto poderá levar a reações impulsivas que afetam o seu ambiente.',
              },
              {
                pageBreak: true,
                title: 'Sugestão',
                description:
                  'Praticar técnicas de respiração e relaxamento antes de momentos desafiadores contribuirá para melhorar a sua capacidade de manter a calma e responder de forma mais controlada.',
              },
            ],
          },
          {
            title: 'Empatía',
            description: '',
            subList: [
              {
                title: 'Área a trabalhar',
                description:
                  'Neste nível, a empatia ainda não está desenvolvida, o que pode levar a problemas em entender as perspectivas de outras pessoas e conectar-se com as suas emoções. Isto poderá traduzir-se em mal-entendidos ou dificuldades em construir relacionamentos de confiança.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de "colocar-se no lugar do outro" e manter uma atitude aberta e não defensiva perante os sentimentos dos outros ajudará a fortalecer esta competência.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área a trabalhar',
                description:
                  'As habilidades sociais encontram-se numa etapa inicial, com limitações para gerir conflitos ou influenciar positivamente grupos. A pessoa poderá sentir-se isolada ou ter dificuldades em colaborar em equipa.',
              },
              {
                title: 'Sugestão',
                description:
                  'Participar em atividades de comunicação assertiva e grupos de apoio pode ser de grande ajuda para melhorar a sua confiança e habilidades interpessoais.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área a trabalhar',
                description:
                  'A motivação interna é baixa, e a pessoa poderá depender de fatores externos para sentir-se impulsionada a alcançar os seus objetivos. É importante fortalecer a motivação intrínseca para manter um foco constante.',
              },
              {
                title: 'Sugestão',
                description:
                  'Definir metas pequenas e alcançáveis, e recompensas-se pelas conquistas obtidas, ajudará a gerar maior satisfação e foco a longo prazo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Construir maior autoconsciência',
            description:
              'Criar um diário emocional para registar as experiências e refletir sobre o que desencadeia certas emoções é uma prática fundamental para identificar padrões e aprender a antecipar as suas respostas emocionais.',
          },
          {
            title: 'Desenvolver a resiliência emocional',
            description:
              'Participar em atividades que fomentem a adaptação a mudanças, como jogos de papéis e cenários simulados, ajudará a pessoa a aprender a gerir melhor as suas emoções perante situações imprevistas.',
          },
          {
            title: 'Melhorar a empatia através da escuta ativa',
            description:
              'Realizar exercícios de escuta ativa em ambientes controlados, onde se pratique a arte de ouvir sem interromper, para poder sintonizar mais facilmente com as emoções dos outros.',
          },
          {
            title: 'Fomentar a automotivação',
            description:
              'Criar um "quadro de visão" com imagens e frases inspiradoras que reflitam os seus objetivos pessoais e profissionais a curto e longo prazo, revendo-o regularmente para manter a motivação alta.',
          },
          {
            title: 'Aumentar a capacidade de gestão de relacionamentos',
            description:
              'Participar em grupos de discussão ou equipas de voluntariado ajudará a pessoa a fortalecer a sua habilidade de conectar-se e colaborar com pessoas com diferentes estilos e antecedentes.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos individuais',
            description:
              'Atividades como corrida, natação ou ciclismo são recomendáveis para desenvolver a autodisciplina e a capacidade de automotivação. Estes desportos permitem à pessoa concentrar-se no seu próprio progresso e gerir o stress de forma saudável.',
          },
          {
            title: 'Yoga ou Pilates',
            description:
              'Praticar yoga ou Pilates é muito útil para fomentar o autocontrolo e a regulação emocional. Por serem atividades que combinam respiração, alongamentos e relaxamento, ajudam a acalmar a mente e reduzir a ansiedade, facilitando uma melhor gestão do stress.',
          },
          {
            title: 'Clubes de leitura ou cinema',
            description:
              'Participar em grupos de leitura ou cinema pode melhorar a capacidade de empatia e a escuta ativa, ao partilhar e interpretar diferentes perspetivas. Refletir sobre personagens e as suas emoções ajuda a entender melhor as experiências dos outros.',
          },
          {
            title: 'Práticas de mindfulness',
            description:
              'Introduzir-se na prática do mindfulness ou da meditação guiada permite desenvolver a autoconsciência, uma vez que promove a observação das emoções e pensamentos sem os julgar. Aplicar estas técnicas no dia a dia contribui para uma maior estabilidade emocional.',
          },
          {
            title: 'Série',
            description:
              '"The Good Place" Esta série combina humor e filosofia para explorar a natureza humana e as emoções. É ideal para refletir sobre a empatia, o sentido de justiça e o desenvolvimento pessoal.',
          },
          {
            title: 'Podcast',
            description:
              '"Entiende Tu Mente" Este podcast em espanhol aborda temas relacionados com a inteligência emocional e a psicologia, oferecendo estratégias simples e quotidianas para melhorar a autogestão e os relacionamentos interpessoais. Ideal para trabalhar a autoconsciência e a empatia de forma prática.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Dixit" Este jogo estimula a imaginação e a interpretação de emoções através de ilustrações, permitindo desenvolver habilidades como a comunicação, a criatividade e a empatia num ambiente lúdico e relaxado.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada tem uma grande oportunidade para desenvolver-se no âmbito da inteligência emocional. Com um foco em fortalecer a sua autoconsciência, autocontrole e empatia, poderá começar a gerir de forma mais eficaz as suas emoções e construir relacionamentos mais satisfatórios e construtivos. Este é apenas o começo de um caminho de desenvolvimento contínuo, e com dedicação e perseverança, poderá alcançar um maior equilíbrio emocional que lhe permita desenvolver-se com confiança tanto a nível pessoal quanto profissional.',
        ],
      },
    ],
    2: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relacionamentos interpessoais sólidos e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do Perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada demonstra um perfil emocional equilibrado, com a capacidade de reconhecer e gerir as suas emoções na maioria das situações. Embora a sua autoconsciência seja adequada, ainda poderá trabalhar em compreender melhor como os seus estados internos afetam as suas decisões. Da mesma forma, demonstra um nível intermédio de empatia e habilidades sociais, o que lhe permite estabelecer relacionamentos funcionais, embora com alguma dificuldade em conectar-se a um nível mais profundo. Este perfil indica que, embora a pessoa tenha desenvolvido uma base sólida de competências emocionais, ainda poderá fortalecer a sua resiliência e a sua capacidade de automotivação, o que lhe permitirá manter o equilíbrio mesmo em momentos de alto stress.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa demonstra uma boa capacidade para reconhecer as suas emoções na maioria das situações quotidianas, mas poderá beneficiar de um trabalho mais focado em identificar como esses sentimentos afetam as suas interações e decisões.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar o monitoramento emocional durante situações de pressão, como reuniões importantes ou momentos de conflito, para identificar que emoções são ativadas e como influenciam o seu comportamento. Manter um registo emocional semanal com foco em situações específicas.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A autogestão que possui permite responder com controle na maioria das circunstâncias. No entanto, poderá sentir problemas ao gerir emoções intensas, como frustração ou ansiedade.',
              },
              {
                pageBreak: true,
                title: 'Sugestão',
                description:
                  'Incorporar técnicas de relaxamento e respiração antes de enfrentar tarefas desafiadoras ou decisões complexas. Além disso, realizar uma pausa intencional (mindful pause) antes de reagir em momentos de stress.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada demonstra um nível de empatia onde é capaz de reconhecer as emoções alheias num ambiente social geral. No entanto, ainda poderá trabalhar em conectar-se mais profundamente, sobretudo em situações que demandem maior compreensão emocional.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a escuta ativa, focando-se em entender tanto o que é dito quanto o que não é dito (emoções subjacentes). Realizar exercícios de role-playing para fomentar a capacidade de colocar-se no lugar do outro.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Apresenta um nível de habilidades sociais que lhe permite interagir de forma construtiva em contextos formais e informais. No entanto, pode sentir-se limitado quando é necessário influenciar um grupo ou liderar iniciativas.',
              },
              {
                title: 'Sugestão',
                description:
                  'Participar em atividades grupais que impliquem liderança partilhada ou coordenação de equipas pequenas para fortalecer a sua capacidade de influência e colaboração.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna que possui permite a capacidade de manter o foco nos seus objetivos pessoais. Ainda assim, poderá beneficiar de uma maior clareza quanto aos seus valores pessoais, para alinhar as suas metas com um propósito mais claro.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de estabelecimento de metas a curto e longo prazo que se conectem com os seus interesses e valores fundamentais. Criar um "mapa de conquistas" para visualizar o seu progresso e manter uma motivação constante.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Desenvolver a autoconsciência',
            description:
              'Realizar práticas de meditação diária de 10 a 15 minutos, focando-se na observação de pensamentos e emoções, sem julgamento.',
          },
          {
            title: 'Fortalecer a resiliência',
            description:
              'Praticar a gestão do stress com técnicas que incluam visualização e regulação emocional.',
          },
          {
            title: 'Potenciar a empatia',
            description:
              'Assistir a workshops ou seminários que abordem a comunicação não verbal e o entendimento de perspetivas alheias.',
          },
          {
            title: 'Ampliar habilidades sociais',
            description:
              'Envolver-se em atividades de networking, onde deva interagir com pessoas desconhecidas e construir novos relacionamentos.',
          },
          {
            title: 'Aumentar a automotivação',
            description:
              'Definir um propósito claro para cada meta e criar um sistema de recompensas pessoais ao alcançá-las.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos individuais',
            description:
              'Atividades como ténis, ginástica ou escalada são excelentes para desenvolver a concentração e a resiliência pessoal. Estas desportos exigem um foco individual e um compromisso constante, o que ajuda a melhorar a autodisciplina e a gerir o stress de forma saudável.',
          },
          {
            pageBreak: true,
            title: 'Atividades de grupo ao ar livre',
            description:
              'Participar em desportos de equipa como futebol, basquetebol ou voleibol contribui para fortalecer as habilidades sociais e a desenvolver maior empatia. A interação e o trabalho em equipa permitem à pessoa aprender a se comunicar melhor, a ouvir ativamente e a colaborar de forma eficaz.',
          },
          {
            title: 'Yoga ou Tai Chi',
            description:
              'Praticar yoga ou tai chi é útil para fomentar o equilíbrio interno e a regulação emocional. Estas atividades combinam respiração, movimentos suaves e meditação, ajudando a reduzir a ansiedade e facilitando uma melhor gestão do stress e de emoções intensas.',
          },
          {
            title: 'Clubes de leitura ou debate',
            description:
              'Unir-se a um clube de leitura ou grupo de debate é ideal para desenvolver a capacidade de escuta ativa e o pensamento crítico. Refletir sobre diferentes pontos de vista e partilhar experiências pode ajudar a melhorar a empatia e a entender melhor as perspetivas dos outros.',
          },
          {
            title: 'Práticas de mindfulness',
            description:
              'Incorporar a prática de mindfulness de forma regular pode fortalecer a autoconsciência e melhorar a capacidade para gerir as emoções. Realizar exercícios de meditação guiada ou de respiração profunda durante 10 minutos todas as manhãs é um bom ponto de partida.',
          },
          {
            title: 'Série',
            description:
              '"This Is Us" Uma série que explora as emoções humanas, os relacionamentos familiares e o crescimento pessoal ao longo da vida. É ideal para refletir sobre a empatia, a gestão de conflitos e o poder do perdão.',
          },
          {
            title: 'Podcast',
            description:
              '"Psicologia para Todos" Um podcast em espanhol que oferece ferramentas práticas e fáceis de aplicar para o desenvolvimento emocional e a gestão de relacionamentos. Os episódios abordam temas como a autoconsciência, a empatia e a motivação.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Codenames" Um jogo que combina estratégia e comunicação, ideal para trabalhar em equipa, afinar as habilidades de observação e potenciar a empatia ao interpretar as pistas de outros jogadores num ambiente divertido e descontraído.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada apresenta um perfil que reflete uma gestão emocional aceitável e uma boa base para o desenvolvimento de uma inteligência emocional avançada. Com um foco em trabalhar a resiliência e a empatia, poderá alcançar um estado de maior estabilidade emocional e tornar-se uma referência na gestão de relacionamentos interpessoais. Este é um ponto de partida sólido que, com o tempo e o esforço adequado, poderá evoluir para um nível de inteligência emocional notável.',
        ],
      },
    ],
    3: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relacionamentos interpessoais sólidos e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do Perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada demonstra um nível avançado de empatia e habilidades sociais, que lhe permitem estabelecer relacionamentos de confiança e compreender as perspectivas dos outros com facilidade. Esta capacidade de sintonizar com as emoções alheias gera um ambiente de apoio e comunicação aberta. No entanto, o perfil "Empático" também poderá beneficiar de trabalhar na gestão das suas próprias emoções, para evitar absorver as cargas emocionais dos outros.',
          'A pessoa avaliada tem a capacidade de adaptar-se a diferentes contextos e de detetar as necessidades emocionais de quem a rodeia. Ainda assim, pode sentir dificuldades em separar as suas próprias emoções das dos outros, o que poderá levar a momentos de saturação emocional. Com um foco em desenvolver habilidades de autogestão e resiliência, esta pessoa poderá alcançar um estado de maior equilíbrio e bem-estar emocional.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada demonstra um nível de autoconsciência onde é capaz de reconhecer as suas emoções na maioria das situações. No entanto, pode ter dificuldades em distinguir entre os seus próprios sentimentos e os das pessoas com quem interage.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar exercícios de "limpeza emocional" ao final do dia, onde se reflita sobre as emoções experienciadas e se identifique quais foram próprias e quais foram absorvidas dos outros.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                pageBreak: true,
                title: 'Área atual',
                description:
                  'A pessoa consegue controlar as suas respostas na maioria das circunstâncias, mas poderá beneficiar de aprender a gerir situações de alta carga emocional sem sentir-se sobrecarregada.',
              },
              {
                title: 'Sugestão',
                description:
                  'Incorporar técnicas de relaxamento progressivo e estabelecer limites emocionais claros em contextos de alta demanda emocional (por exemplo, conversas intensas ou situações de conflito).',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A sua empatia permite-lhe conectar-se com os outros e criar relacionamentos interpessoais sólidos. No entanto, deve trabalhar em não deixar-se levar completamente pelas emoções alheias.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de autorreflexão e aprender a dizer "não" de forma assertiva quando sentir que as emoções de outras pessoas começam a impactar negativamente o seu próprio estado emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada consegue gerir conflitos com diplomacia e resolver problemas em equipa de forma eficaz. No entanto, poderá focar-se mais na tomada de decisões assertivas para evitar ser complacente.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar técnicas de liderança assertiva e realizar simulações de tomada de decisões em grupo para fortalecer a sua capacidade de influenciar positivamente sem cair na sobreproteção dos outros.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna que possui impulsiona um forte desejo de ajudar e gerar um impacto positivo no ambiente. Ainda assim, poderá beneficiar de estabelecer metas mais equilibradas, que considerem tanto as suas necessidades quanto as das pessoas ao seu redor.',
              },
              {
                title: 'Sugestão',
                description:
                  'Definir objetivos pessoais claros que não estejam unicamente focados nos outros, mas que reflitam um equilíbrio entre o autocuidado e o apoio aos outros.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fomentar o autocuidado emocional',
            description:
              'Estabelecer rotinas de desconexão ao final do dia para libertar as tensões acumuladas e recentrar-se nas suas próprias necessidades.',
          },
          {
            title: 'Estabelecer limites saudáveis',
            description:
              'Aprender a dizer "não" de forma assertiva quando se perceba que se está a sobrecarregar emocionalmente.',
          },
          {
            title: 'Praticar a separação emocional',
            description:
              'Implementar a técnica de "ancoragem", onde a pessoa visualiza um símbolo ou palavra que lhe recorda a sua própria estabilidade emocional, evitando assim ser absorvida pelas emoções alheias.',
          },
          {
            title: 'Fortalecer a motivação intrínseca',
            description:
              'Realizar uma listagem de objetivos pessoais que não dependam da aprovação ou satisfação dos outros, mas que reflitam metas próprias.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos individuais ou de pares',
            description:
              'O padel ou ténis são ideais para equilibrar a necessidade de conexão com outros sem perder a concentração em si mesmo. Estas atividades ajudam a libertar tensões e a manter um foco equilibrado entre o próprio e o partilhado.',
          },
          {
            title: 'Práticas de meditação guiada',
            description:
              'O uso de aplicações como Insight Timer ou Headspace pode ser útil para realizar meditações centradas na autocompaixão e no fortalecimento de limites emocionais.',
          },
          {
            pageBreak: true,
            title: 'Clubes de discussão e voluntariado',
            description:
              'Participar em atividades de voluntariado ou clubes de discussão temática (literatura, cinema, filosofia) ajuda a pessoa a continuar a conectar-se com os outros sem perder o seu próprio espaço de reflexão e crescimento pessoal.',
          },
          {
            title: 'Série',
            description:
              '"Atypical" Uma série que explora as emoções, o autismo e a capacidade de cada pessoa para compreender o mundo de maneira única. Ideal para refletir sobre a empatia e a gestão das emoções em situações quotidianas.',
          },
          {
            title: 'Podcast',
            description:
              '"Emotions Matter" Um podcast em inglês que aborda diferentes abordagens sobre a inteligência emocional, com convidados que partilham ferramentas para gerir situações emocionais complexas e manter o equilíbrio emocional.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"The Mind" Um jogo cooperativo onde os jogadores devem sincronizar-se sem falar para colocar cartas na ordem correta. É ideal para desenvolver a intuição emocional e a conexão interpessoal.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra uma capacidade inata para conectar-se com as emoções alheias e construir relacionamentos baseados na compreensão e no apoio mútuo. Estas habilidades permitem-lhe detetar necessidades emocionais no seu ambiente com facilidade, atuando como uma ponte entre as pessoas e promovendo um ambiente de colaboração e respeito. No entanto, esta mesma habilidade de empatizar profundamente pode levar a momentos de sobrecarga emocional, especialmente quando se envolve em excesso com os problemas dos outros ou quando não estabelece limites claros para proteger o seu próprio bem-estar.',
          'O desafio para a pessoa avaliada é alcançar um equilíbrio entre prestar apoio aos outros e preservar a sua própria estabilidade emocional. A chave está em fortalecer a autogestão, trabalhar na regulação emocional e aprender a desconectar quando necessário, sem perder a sensibilidade que a caracteriza. Com um desenvolvimento consciente nestas áreas, a pessoa avaliada pode alcançar um estado de maior resiliência e clareza emocional, tornando-se uma referência positiva nos seus ambientes pessoais e profissionais.',
          'Com o tempo, ao aperfeiçoar as suas habilidades de autocuidado e aprender a reconhecer quando e como envolver-se emocionalmente, a pessoa avaliada poderá maximizar o seu impacto de maneira equilibrada. Isto não só lhe permitirá manter a sua própria energia e motivação a longo prazo, mas também inspirar aqueles que a rodeiam a serem mais conscientes, compassivos e emocionalmente inteligentes.',
        ],
      },
    ],
    4: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relacionamentos interpessoais sólidos e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do Perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada apresenta um perfil que se caracteriza pela sua alta capacidade para trabalhar em equipa, a sua disposição para cooperar e o seu desejo de fomentar um ambiente de apoio mútuo. Tende a priorizar o bem-estar do grupo e a criar um ambiente de harmonia no qual as pessoas se sintam incluídas e valorizadas. Esta tendência para colaborar pode facilitar a resolução de problemas e o alcance de objetivos comuns de maneira eficiente.',
          'No entanto, a pessoa avaliada poderá beneficiar de trabalhar na sua assertividade para não cair numa atitude complacente ou de sacrifício pessoal pelo bem do grupo. Além disso, ao focar-se tanto no trabalho em equipa, pode sentir dificuldades para tomar decisões sozinha ou para priorizar as suas próprias necessidades. Com um desenvolvimento consciente de habilidades de autogestão e tomada de decisões individuais, esta pessoa poderá alcançar um maior equilíbrio entre o seu desejo de colaborar e a sua capacidade para manter um foco pessoal, assegurando um impacto positivo tanto a nível grupal quanto individual.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada demonstra um nível de autoconsciência que lhe permite uma compreensão geral das suas emoções em ambientes grupais. No entanto, pode perder a conexão com os seus próprios sentimentos quando o grupo atravessa momentos de tensão.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a autoavaliação ao final de cada interação grupal, identificando os seus próprios estados emocionais e refletindo sobre como estes influenciaram as suas contribuições para o grupo.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Costuma regular as suas respostas para evitar conflitos, mas pode tornar-se complacente em situações onde se requer uma abordagem mais firme.',
              },
              {
                title: 'Sugestão',
                description:
                  'Desenvolver técnicas de regulação emocional, como a visualização positiva e o estabelecimento de limites, para fortalecer a sua capacidade de manter uma postura equilibrada mesmo quando o grupo pressiona por decisões rápidas.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Tem a habilidade de colocar-se no lugar dos outros e de entender as dinâmicas emocionais de cada integrante da equipa. No entanto, por vezes pode sobrecarregar-se emocionalmente ao tentar mediar conflitos ou resolver problemas alheios.',
              },
              {
                title: 'Sugestão',
                description:
                  'Implementar a prática de "distanciamento empático", onde reflita sobre quando envolver-se profundamente e quando é melhor adotar uma abordagem mais neutra para evitar esgotamento emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem uma capacidade natural para interagir de maneira eficaz em grupos e para fomentar a cooperação entre os membros da equipa. No entanto, poderá trabalhar em assumir um papel de liderança mais ativo quando a situação o requerer.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar simulações de liderança e participar em projetos grupais com papéis rotativos, o que lhe permitirá adquirir mais confiança na sua capacidade para influenciar positivamente sem perder o foco colaborativo.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna está orientada para o alcance grupal e a criação de um ambiente de bem-estar. Embora isto impulsione o seu desejo de colaborar, poderá beneficiar de definir metas individuais que também considerem os seus interesses e ambições pessoais.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de estabelecimento de objetivos pessoais que se alinhem com os seus valores, mas que não dependam exclusivamente do sucesso da equipa.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fortalecer a autoconfiança',
            description:
              'Realizar atividades que promovam a tomada de decisões a sós, como projetos pessoais ou situações de liderança individual.',
          },
          {
            title: 'Fomentar a separação emocional',
            description:
              'Praticar técnicas de mindfulness para refletir sobre quando assumir um papel ativo e quando manter-se num papel de observador para não se sentir sobrecarregada pelas dinâmicas grupais.',
          },
          {
            title: 'Aumentar a capacidade de automotivação',
            description:
              'Criar um sistema de conquistas pessoais que se mantenha independente do sucesso grupal, assegurando que as metas individuais também sejam priorizadas.',
          },
          {
            title: 'Ampliar a capacidade de influência',
            description:
              'Participar em atividades de negociação e resolução de conflitos para fortalecer a capacidade de tomar decisões difíceis em nome do grupo.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos de equipa',
            description:
              'O futebol, basquetebol ou voleibol são ideais para potenciar as habilidades colaborativas, enquanto se trabalha a tomada de decisões rápidas e a gestão da pressão num ambiente de grupo.',
          },
          {
            pageBreak: true,
            title: 'Grupos de discussão e debate',
            description:
              'Unir-se a grupos de debate é útil para melhorar a capacidade de expressar as suas ideias com clareza, ao mesmo tempo que se mantém o respeito e a consideração pelas opiniões alheias.',
          },
          {
            title: 'Práticas de mindfulness',
            description:
              'O uso de aplicações de mindfulness como Headspace ou Calm pode ajudar a pessoa a reconectar-se consigo mesma após longas jornadas de interação grupal.',
          },
          {
            title: 'Série',
            description:
              '"Brooklyn Nine-Nine" Uma série que aborda de maneira humorística as dinâmicas de grupo, o trabalho colaborativo e a liderança partilhada, ideal para refletir sobre como se gerem as emoções dentro de uma equipa.',
          },
          {
            title: 'Podcast',
            description:
              '"The Team Building Show" Um podcast que explora técnicas e estratégias para construir equipas coesas, com episódios que abordam temas como a comunicação eficaz, a resolução de conflitos e a motivação grupal.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Pandemic" Um jogo cooperativo onde os jogadores devem trabalhar juntos para salvar o mundo de uma epidemia global. Ideal para desenvolver habilidades de comunicação, planeamento e tomada de decisões em equipa.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra uma grande capacidade para fomentar a colaboração e o apoio mútuo num ambiente grupal, atuando como um ponto de referência para o trabalho em equipa. Com a sua habilidade para gerar coesão e a sua disposição para ajudar, tende a priorizar o sucesso do grupo acima do próprio. No entanto, é fundamental que também se foque em desenvolver a sua autogestão e em definir metas pessoais claras, para evitar cair na complacência e manter um equilíbrio entre o seu bem-estar individual e o da equipa.',
          'Ao trabalhar na sua assertividade e fortalecer a sua capacidade para tomar decisões de maneira independente, a pessoa avaliada poderá maximizar o seu impacto de maneira equilibrada, assegurando que o seu enfoque colaborativo não a leve a sacrifícios desnecessários. Com o tempo, poderá tornar-se um líder que inspire os outros a colaborar com empatia e eficácia, gerando um ambiente de trabalho harmonioso e bem-sucedido para todos.',
        ],
      },
    ],
    5: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relacionamentos interpessoais sólidos e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do Perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada apresenta um nível avançado de autoconsciência, o que lhe permite identificar e entender as suas próprias emoções com facilidade, bem como refletir sobre como estas afetam o seu comportamento e as suas decisões. Este nível de autoconhecimento proporciona uma base sólida para a gestão emocional e a tomada de decisões conscientes, o que resulta em interações interpessoais claras e eficazes.',
          'No entanto, a pessoa avaliada poderá beneficiar de trabalhar na sua flexibilidade emocional, já que uma abordagem excessivamente introspetiva poderá levá-la a focar-se demasiado nos seus próprios estados emocionais e a perder de vista as necessidades e emoções dos outros. Por vezes, esta tendência pode dificultar a adaptação a mudanças inesperadas ou a contextos nos quais se requer uma abordagem mais espontânea e menos analítica. Com um desenvolvimento focado na regulação emocional e na ampliação da sua perspetiva para o ambiente, a pessoa avaliada poderá alcançar um nível ainda maior de inteligência emocional, gerindo não só as suas próprias emoções, mas também conectando-se de maneira mais profunda com as de quem a rodeia.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Tem uma grande capacidade para reconhecer as suas emoções e compreender as suas causas, o que lhe permite refletir sobre as suas ações e manter um alto nível de autocrítica positiva.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a autocompaixão, especialmente em momentos de autocrítica excessiva. Realizar exercícios de mindfulness centrados em aceitar as suas emoções sem necessidade de avaliá-las de imediato pode ser de grande ajuda.',
              },
            ],
          },
          {
            pageBreak: true,
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada demonstra uma boa capacidade de autogestão na maioria das situações, mas poderá sentir dificuldades em manter-se flexível em contextos de alta pressão ou incerteza.',
              },
              {
                title: 'Sugestão',
                description:
                  'Implementar técnicas de adaptação emocional, como a visualização de possíveis resultados e a criação de planos alternativos, para desenvolver uma maior resiliência perante mudanças imprevistas.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Embora a pessoa avaliada tenha um nível adequado de empatia, o seu forte foco na introspetiva poderá levá-la a concentrar-se mais nas suas próprias emoções e a deixar de lado, por vezes, os sinais emocionais do seu ambiente.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de escuta ativa, focando-se em interpretar a linguagem não verbal e as nuances emocionais dos outros, para equilibrar a sua perceção interna com uma compreensão mais completa das emoções alheias.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'As habilidades sociais que possui são adequadas, especialmente em ambientes onde se valorizam as conversas profundas e o entendimento mútuo. No entanto, a pessoa avaliada poderá trabalhar em situações que requeiram uma resposta rápida e espontânea.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a improvisação em situações controladas, como jogos de papéis ou simulações de interação nas quais deva reagir sem uma análise prévia, para fomentar uma maior agilidade emocional e comunicacional.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna é sólida e está impulsionada por um forte desejo de crescimento pessoal e autodescoberta. Ainda assim, a pessoa avaliada poderá beneficiar de definir objetivos que se centrem no seu ambiente e em como o seu desenvolvimento pessoal pode impactar positivamente os outros.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar um plano de desenvolvimento que combine metas pessoais com metas relacionais, de maneira que a sua motivação abranja tanto o crescimento interno quanto o impacto externo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fomentar a flexibilidade emocional',
            description:
              'Desenvolver a capacidade de adaptar-se a diferentes contextos mediante exercícios de "mindfulness adaptativo", onde se trabalhe a aceitação de mudanças e se reflita sobre como responder de maneira positiva.',
          },
          {
            title: 'Fortalecer a conexão interpessoal',
            description:
              'Participar em atividades de escuta ativa e empatia reflexiva, como workshops de comunicação não verbal e exercícios de role-playing para ampliar a perceção emocional para o ambiente.',
          },
          {
            title: 'Aumentar a agilidade emocional',
            description:
              'Realizar exercícios de improvisação e participação em dinâmicas grupais que impliquem respostas rápidas e espontâneas, para sair da zona de conforto de análise contínua.',
          },
          {
            title: 'Integrar objetivos pessoais e relacionais',
            description:
              'Definir metas que incluam um equilíbrio entre o desenvolvimento próprio e o impacto positivo nas pessoas com as quais se interage.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos individuais e de equipa',
            description:
              'O ténis, a escalada ou o futsal podem ajudar a pessoa a desenvolver a capacidade de tomar decisões rápidas enquanto gere as suas próprias emoções. Estas atividades permitem combinar a introspetiva com a necessidade de ação e reação imediata.',
          },
          {
            pageBreak: true,
            title: 'Clubes de debate ou palestras filosóficas',
            description:
              'Unir-se a grupos de debate é ideal para melhorar a capacidade de responder de maneira ágil e espontânea a ideias opostas. Isto ajuda a sair de um enfoque puramente introspetivo e a praticar a escuta ativa em ambientes desafiadores.',
          },
          {
            title: 'Práticas de meditação consciente adaptativa',
            description:
              'O uso de meditações adaptativas, que se centram em aceitar mudanças no ambiente ou nas emoções, pode ajudar a pessoa avaliada a melhorar a sua capacidade de adaptação e a gerir melhor situações inesperadas.',
          },
          {
            title: 'Série',
            description:
              '"The Crown" Uma série que explora o desenvolvimento pessoal e a gestão das emoções em contextos de grande responsabilidade e pressão. Ideal para refletir sobre a autogestão e a tomada de decisões em momentos críticos.',
          },
          {
            title: 'Podcast',
            description:
              '"Hidden Brain" Um podcast que explora como a mente e as emoções afetam as decisões. Os episódios abordam temas como a autoconsciência, a tomada de decisões e a adaptação emocional, proporcionando ferramentas práticas para o desenvolvimento pessoal.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Dixit" Um jogo que estimula a interpretação de emoções através de ilustrações e metáforas. Ideal para fomentar a flexibilidade emocional e a capacidade de ver diferentes perspetivas sem ficar preso num único ponto de vista.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra um nível elevado de autoconsciência, o que lhe permite identificar as suas emoções de maneira clara e refletir sobre como estas influenciam as suas decisões e relações. Esta capacidade de introspetiva concede-lhe uma vantagem para reconhecer os seus próprios padrões de comportamento, o que facilita o desenvolvimento de estratégias para gerir-se de maneira eficaz em distintas situações.',
          'No entanto, devido ao seu enfoque analítico e à sua tendência para refletir profundamente, é possível que em alguns momentos perca de vista os sinais emocionais do ambiente ou que se mostre menos flexível perante mudanças imprevistas. O desafio principal é equilibrar o seu desejo de autocompreensão com uma maior abertura e adaptação ao seu ambiente, de maneira que não se sinta presa num ciclo de autoavaliação constante que possa limitar a sua capacidade para atuar com espontaneidade e fluidez.',
          'Para alcançar um desenvolvimento mais integral, é importante que a pessoa avaliada trabalhe na sua flexibilidade emocional e em fortalecer a sua conexão com as emoções alheias. Aprender a soltar o controle quando necessário e aceitar as suas próprias emoções sem a necessidade de analisá-las em excesso permitir-lhe-á manter um equilíbrio saudável entre a reflexão interna e a ação externa.',
          'Com um enfoque nestas áreas, a pessoa avaliada poderá integrar a sua autoconsciência com uma maior empatia e abertura para os outros, permitindo-lhe tomar decisões mais equilibradas e reagir de maneira mais ágil e eficaz perante situações inesperadas. Isto não só beneficiará o seu desenvolvimento pessoal, mas também lhe permitirá impactar positivamente o seu ambiente, contribuindo com a sua clareza emocional e capacidade para adaptar-se às necessidades do momento.',
        ],
      },
    ],
    6: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relacionamentos interpessoais sólidos e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do Perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada apresenta um nível avançado de autogestão e regulação emocional. Isto significa que tem a capacidade de manter a calma e o controlo na maioria das situações, mesmo naquelas de alta pressão ou conflito. A sua abordagem é equilibrada e costuma gerir as suas emoções de maneira eficaz, respondendo com clareza e serenidade em vez de reagir de forma impulsiva. Esta competência permite-lhe enfrentar desafios com uma atitude proativa e resolver problemas com maior clareza e eficiência.',
          'No entanto, devido à sua forte tendência ao controlo emocional, a pessoa avaliada poderá sentir dificuldades em expressar livremente as suas emoções em situações onde se requer maior espontaneidade ou abertura. Por vezes, o seu desejo de manter a compostura pode levá-la a suprimir sentimentos que precisam de ser comunicados, o que poderá gerar tensões internas ou uma perceção de rigidez nos seus relacionamentos interpessoais. Com um desenvolvimento consciente na expressão emocional e na construção de um espaço seguro para partilhar os seus sentimentos de maneira mais aberta, a pessoa avaliada poderá alcançar um estado de maior equilíbrio, combinando a sua alta capacidade de regulação com uma conexão mais profunda e autêntica com o seu ambiente.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem um nível de autoconsciência que lhe permite identificar quando uma emoção surge e como esta poderá influenciar o seu comportamento. No entanto, por vezes poderá não dar espaço suficiente aos seus sentimentos para se manifestarem.',
              },
              {
                pageBreak: true,
                title: 'Sugestão',
                description:
                  'Realizar exercícios de auto-observação centrados na expressão emocional. Identificar momentos em que reprime ou modera as suas emoções e perguntar-se qual seria a maneira mais equilibrada de manifestá-las sem perder a sua autogestão.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Possui um controlo significativo sobre as suas reações emocionais, o que lhe permite lidar com conflitos com serenidade e resolver problemas de maneira eficaz. No entanto, pode tornar-se demasiado autoexigente quando se enfrenta a situações de alta pressão.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar exercícios de relaxamento e fazer pausas intencionais para reduzir a tensão interna. Introduzir atividades de desconexão, como caminhadas ou exercícios de respiração consciente, para evitar o esgotamento por uma regulação excessiva.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem um nível de empatia em que é capaz de entender como as suas respostas impactam os outros. No entanto, poderá trabalhar em mostrar o seu lado emocional de maneira mais aberta para gerar uma conexão mais autêntica.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de abertura emocional, como a prática de partilhar experiências pessoais em ambientes seguros, para fortalecer a empatia através de uma maior transparência emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem boas habilidades sociais e tende a ser percebida como uma pessoa estável e confiável em ambientes de trabalho e no seu círculo próximo. No entanto, o seu autocontrolo poderá ser interpretado como distanciamento em situações que requerem maior expressão emocional.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar técnicas de comunicação emocional e participar em grupos de discussão onde se fomente a abertura e a troca de sentimentos, para equilibrar a sua estabilidade com uma expressão mais visível das suas emoções.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna da pessoa avaliada está orientada para a conquista e a superação pessoal. Costuma manter um alto nível de energia e perseverança, mas poderá beneficiar de se focar em metas que também incluam o desenvolvimento do seu lado emocional.',
              },
              {
                title: 'Sugestão',
                description:
                  'Definir objetivos que não se foquem apenas na gestão das suas emoções, mas também no desenvolvimento da abertura e da aceitação emocional, buscando um equilíbrio entre controlo e expressão.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fomentar a expressão emocional saudável',
            description:
              'Desenvolver a capacidade de expressar emoções de maneira clara e direta através de técnicas de comunicação assertiva e exercícios de escrita emocional.',
          },
          {
            title: 'Trabalhar na flexibilidade emocional',
            description:
              'Praticar atividades como jogos de papéis ou improvisação, onde deva adaptar-se rapidamente a mudanças de contexto emocional, para quebrar a tendência à rigidez.',
          },
          {
            title: 'Criar um espaço de abertura',
            description:
              'Participar em grupos de apoio ou atividades onde se fomente a abertura emocional e a confiança, para fortalecer a capacidade de partilhar os seus sentimentos de maneira segura.',
          },
          {
            title: 'Fortalecer a conexão interpessoal',
            description:
              'Realizar dinâmicas grupais ou atividades de voluntariado que requeiram a criação de um vínculo emocional com os outros, equilibrando a regulação com uma maior conexão empática.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            pageBreak: true,
            title: 'Desportos que combinam autocontrolo e expressão',
            description:
              'O ioga, o boxe ou o tai chi são ideais para equilibrar o controlo e a libertação emocional. Estas atividades ajudam a pessoa a manter a sua estabilidade interna, ao mesmo tempo que permitem uma maior expressão através do movimento.',
          },
          {
            title: 'Práticas de escrita emocional',
            description:
              'Escrever num diário emocional ou realizar exercícios de escrita livre pode ajudar a pessoa avaliada a explorar e expressar sentimentos que usualmente mantém sob controlo. Refletir sobre as suas emoções através da escrita pode ser uma forma eficaz de libertar a tensão emocional acumulada.',
          },
          {
            title: 'Clubes de expressão criativa',
            description:
              'Unir-se a grupos de teatro, oficinas de arte ou aulas de improvisação é ideal para trabalhar na abertura e na flexibilidade emocional num ambiente seguro e guiado, permitindo à pessoa explorar novas formas de expressar as suas emoções.',
          },
          {
            title: 'Série',
            description:
              '"This Is Us" Uma série que explora as emoções humanas de maneira profunda e honesta. Ideal para refletir sobre a importância da expressão emocional e como as dinâmicas familiares impactam a regulação das emoções.',
          },
          {
            title: 'Podcast',
            description:
              '"The Science of Happiness" Um podcast que aborda estratégias baseadas na ciência para manter um equilíbrio emocional, com episódios centrados em como gerir as emoções e desenvolver um bem-estar integral.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Codenames" Um jogo que combina estratégia e comunicação, ideal para trabalhar em equipa e praticar a paciência e a clareza na expressão, mantendo o controlo sem perder a espontaneidade.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra uma grande capacidade para gerir as suas emoções de maneira eficaz, mantendo a calma e o controlo inclusive em situações de alta pressão. Esta habilidade permite-lhe tomar decisões claras e equilibradas, o que a converte numa referência de estabilidade e confiabilidade no seu ambiente. Graças à sua capacidade de autogestão, costuma enfrentar os desafios com serenidade e atua de forma proativa para resolver problemas sem se deixar levar por impulsos ou reações emocionais negativas.',
          'No entanto, o forte controlo emocional que exerce também pode levá-la a reprimir os seus próprios sentimentos ou a mostrar-se demasiado reservada em situações que requerem uma maior expressão emocional e autenticidade. Esta tendência a manter sempre a compostura poderá dificultar a criação de relacionamentos mais profundos e próximos, já que os outros podem percebê-la como distante ou inacessível em contextos que requerem uma maior abertura emocional.',
          'Para alcançar um desenvolvimento emocional mais completo, é importante que a pessoa avaliada trabalhe em encontrar um equilíbrio entre a regulação e a expressão. Aprender a comunicar as suas emoções de maneira mais aberta e mostrar o seu lado vulnerável num ambiente seguro permitir-lhe-á fortalecer os seus relacionamentos interpessoais e criar um espaço de maior confiança mútua. A chave está em aceitar que mostrar os seus sentimentos não é um sinal de fraqueza, mas uma forma de conectar-se de maneira autêntica com os outros.',
          'Com o tempo, ao integrar a sua capacidade de regulação com uma expressão emocional mais livre e sincera, a pessoa avaliada poderá alcançar um equilíbrio mais profundo e converter-se num modelo não só de estabilidade, mas também de abertura e proximidade. Isto não só beneficiará o seu desenvolvimento pessoal, mas também lhe permitirá influenciar positivamente o seu ambiente, gerando um ambiente em que o autocontrolo e a expressão emocional coexistam de maneira harmónica, promovendo relacionamentos baseados na confiança, no respeito e na empatia.',
        ],
      },
    ],
    7: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relações interpessoais sólidas e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada apresenta um nível alto de motivação interna, o que significa que se sente impulsionada por metas e objetivos que vão além de fatores externos. A sua capacidade para se automotivar e manter o foco permite-lhe abordar projetos com entusiasmo e persistência, mostrando um forte desejo de alcançar resultados positivos. Esta energia constante confere-lhe um impulso adicional para enfrentar desafios e superar-se a si mesma, o que a torna alguém orientado para a conquista e com um espírito de superação.',
          'No entanto, este nível de motivação poderá levar a pessoa avaliada, por vezes, a priorizar o cumprimento dos seus objetivos acima do seu bem-estar pessoal, especialmente quando se encontra sob pressão. Além disso, o seu impulso constante para alcançar novas metas poderá dificultar-lhe desfrutar do processo e desligar-se de maneira adequada, gerando um risco de esgotamento ou desmotivação quando as coisas não correm como planeado. Para alcançar um equilíbrio mais saudável, a pessoa avaliada poderá beneficiar de trabalhar na sua capacidade para gerir a frustração e aprender a desfrutar das pequenas conquistas no caminho para os seus objetivos principais. Com um foco em desenvolver um maior autocuidado e uma perspetiva mais flexível, poderá manter o seu nível de motivação alto sem comprometer o seu bem-estar emocional.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada demonstra uma boa capacidade para reconhecer as suas próprias metas e o que a impulsiona a alcançá-las. No entanto, poderia beneficiar de um trabalho adicional para identificar quando a sua motivação começa a cruzar o limite para a autoexigência.',
              },
              {
                pageBreak: true,
                title: 'Sugestão',
                description:
                  'Incorporar exercícios de reflexão no final de cada semana para avaliar que conquistas foram obtidas e que aprendizagens foram geradas, permitindo-se celebrar as pequenas vitórias e não apenas os grandes resultados.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A autogestão é sólida, permitindo que a pessoa se mantenha focada nos seus objetivos e gestione as suas emoções em função do que precisa alcançar. No entanto, poderia trabalhar em ser mais flexível com as metas e em aprender a ajustar-se às mudanças sem que isso afete a sua motivação.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a criação de planos alternativos (Plano B e C) ao definir os seus objetivos, para desenvolver uma maior resiliência e aceitação quando surgem contratempos.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Embora a pessoa avaliada tenha a capacidade de empatizar com quem a rodeia, a sua forte orientação para a conquista poderá levá-la a focar-se mais nos seus próprios objetivos do que nas necessidades emocionais dos outros.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de "revisão empática" onde, após cada projeto ou interação em grupo, reflita sobre o impacto emocional que teve nos outros e como poderia equilibrar melhor as suas metas com as do seu ambiente.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada possui boas habilidades sociais e tende a ser percebida como alguém com grande energia e entusiasmo, capaz de contagiar os outros com o seu espírito de superação. No entanto, poderia trabalhar em ser mais paciente e compreensiva quando os outros não partilham o mesmo nível de motivação.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a escuta ativa em contextos de equipa, permitindo que outros partilhem os seus pontos de vista sem interromper, para desenvolver uma maior capacidade de contenção e compreensão em relação a diferentes perspetivas.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Sente uma energia constante e um desejo inato de alcançar as suas metas e desenvolver-se continuamente. No entanto, este alto nível de motivação também poderá tornar-se uma arma de dois gumes se não for acompanhado por um equilíbrio entre conquista e prazer.',
              },
              {
                title: 'Sugestão',
                description:
                  'Incorporar momentos de descanso programado e celebrar cada avanço como um sucesso em si mesmo, para manter a motivação sem gerar esgotamento a longo prazo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fomentar a flexibilidade emocional',
            description:
              'Aprender a adaptar as suas metas e expectativas quando as circunstâncias mudam, sem que isso afete a sua motivação de maneira negativa.',
          },
          {
            title: 'Desenvolver a autocompaixão',
            description:
              'Incorporar práticas de autocompaixão para evitar a autoexigência excessiva, especialmente em momentos de frustração ou quando os objetivos não são alcançados à primeira.',
          },
          {
            title: 'Criar um equilíbrio entre conquista e bem-estar',
            description:
              'Definir momentos específicos de desconexão e descanso durante a semana para desfrutar de outras atividades que não estejam relacionadas com os seus objetivos principais.',
          },
          {
            title: 'Fortalecer a conexão interpessoal',
            description:
              'Participar em atividades de grupo onde se valorize o processo colaborativo mais do que o resultado final, para desenvolver uma maior conexão com o seu ambiente.',
          },
        ],
      },
      {
        pageBreak: true,
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos que envolvam metas e superação pessoal',
            description:
              'A corrida, o crossfit ou o triatlo são ideais para manter o foco em objetivos de crescimento pessoal e medir o progresso de maneira constante. No entanto, é importante acompanhar estes desportos com atividades de relaxamento para evitar o esgotamento.',
          },
          {
            title: 'Atividades de equipa com foco em processos',
            description:
              'Participar em equipas desportivas recreativas (por exemplo, voleibol ou futebol amador) onde o objetivo principal não seja ganhar, mas desfrutar do processo, ajudará a pessoa avaliada a manter o equilíbrio entre motivação e prazer.',
          },
          {
            title: 'Práticas de mindfulness focadas no aqui e agora',
            description:
              'Introduzir a prática de mindfulness para se centrar no presente sem perder de vista as metas a longo prazo. Aplicações como Headspace ou Calm podem ser úteis para criar uma rotina de mindfulness que fomente o equilíbrio emocional.',
          },
          {
            title: 'Série',
            description:
              '"Chef\'s Table" Uma série que explora a motivação e a paixão de chefs de renome mundial. Ideal para refletir sobre o processo criativo e como se combinam o esforço, a motivação e o bem-estar pessoal para alcançar a excelência.',
          },
          {
            title: 'Podcast',
            description:
              '"The Tim Ferriss Show" Um podcast que aborda a motivação, a produtividade e o desenvolvimento pessoal, com entrevistas a pessoas de alto desempenho que partilham as suas estratégias para se manterem motivadas e equilibradas.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Azul" Um jogo estratégico que requer planeamento e precisão para completar padrões. É ideal para trabalhar a paciência, o foco e a flexibilidade emocional quando as metas não são alcançadas imediatamente.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra um alto nível de motivação interna, o que lhe permite enfrentar desafios com energia e persistência, mantendo um foco constante nas suas metas. O seu desejo de alcançar objetivos e superar-se a si mesma impulsiona um espírito de crescimento e desenvolvimento contínuo, tornando-a alguém com grande capacidade para inspirar quem a rodeia. Além disso, esta forte orientação para a conquista confere-lhe uma vantagem significativa em contextos competitivos e permite-lhe manter uma atitude positiva mesmo perante obstáculos e dificuldades.',
          'No entanto, este alto nível de motivação também acarreta certos desafios. A pessoa avaliada poderá encontrar-se, por vezes, a priorizar as suas metas acima do seu bem-estar pessoal, ou até mesmo a sentir uma pressão constante para render ao máximo, o que poderá levá-la à autoexigência excessiva ou ao esgotamento. A chave para alcançar um desenvolvimento emocional equilibrado está em aprender a aceitar que o descanso e a desconexão também fazem parte do caminho para o sucesso e que nem todos os avanços se medem em termos de produtividade ou resultados imediatos.',
          'O desafio para a pessoa avaliada é encontrar um equilíbrio onde a sua motivação não seja afetada por contratempos e onde o processo de alcançar metas seja tão satisfatório quanto a própria conquista. Ao integrar momentos de reflexão e autocuidado, poderá aprender a desfrutar do caminho, celebrando cada pequeno passo como uma vitória em si mesma. Esta integração permitir-lhe-á manter a sua energia alta e a sua motivação constante sem comprometer o seu bem-estar emocional, assegurando um progresso sustentável a longo prazo.',
          'Com o tempo, ao aperfeiçoar a sua capacidade para equilibrar o impulso para a conquista com um maior prazer do presente, a pessoa avaliada poderá tornar-se uma referência de motivação saudável e bem-estar integral. Não só alcançará as suas metas de maneira mais consciente e plena, mas também inspirará outros a procurar uma abordagem equilibrada, demonstrando que a verdadeira motivação não se baseia na constante busca por resultados, mas na capacidade de manter a paixão e a energia ao longo de todo o caminho.',
        ],
      },
    ],
    8: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relações interpessoais sólidas e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada apresenta um perfil altamente estratégico, com uma capacidade avançada para planear e organizar tanto as suas emoções quanto as suas ações de maneira que se alinhem com os seus objetivos a longo prazo. Costuma ser uma pessoa com uma grande visão e foco, o que lhe permite antecipar possíveis obstáculos e adaptar-se rapidamente às mudanças. Esta habilidade permite-lhe responder de maneira equilibrada e lógica a situações complexas, abordando-as com uma mentalidade analítica e resolutiva.',
          'No entanto, esta forte orientação estratégica também pode levar a que a pessoa avaliada se foque excessivamente nos resultados e perca de vista a importância do processo e das relações interpessoais no caminho para os seus objetivos. Além disso, o seu foco no planeamento e na eficiência poderá fazer com que, ocasionalmente, se mostre menos flexível perante situações que requerem improvisação ou espontaneidade. Para alcançar um desenvolvimento mais equilibrado, a pessoa avaliada poderá beneficiar de trabalhar em ser mais aberta à incerteza e em aceitar que nem tudo se pode prever ou planear. Aprender a adaptar-se a situações inesperadas com uma maior abertura emocional e a valorizar as experiências no presente permitir-lhe-á não só alcançar os seus objetivos, mas também desfrutar mais do caminho.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada demonstra um nível de autoconsciência onde a capacidade de identificar as suas emoções e compreender como estas influenciam as suas decisões estratégicas. No entanto, poderia trabalhar em reconhecer quando o seu enfoque analítico começa a limitar a sua abertura a novas experiências.',
              },
              {
                pageBreak: true,
                title: 'Sugestão',
                description:
                  'Praticar a auto-observação durante momentos de improvisação ou mudanças inesperadas, identificando como a sua mente procura controlar a situação e explorando formas de aceitar a incerteza com maior flexibilidade.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'Possui uma grande capacidade para regular as suas emoções e manter o foco nas suas metas, mesmo em situações de alta pressão. No entanto, poderia beneficiar de aprender a incorporar momentos de relaxamento e descanso para evitar um planeamento excessivo que gere rigidez.',
              },
              {
                title: 'Sugestão',
                description:
                  'Estabelecer momentos específicos de desconexão na sua rotina diária, onde possa permitir-se atuar de maneira espontânea sem um plano predeterminado, para equilibrar a estrutura com a flexibilidade.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada é capaz de entender as emoções alheias e antecipar como as suas ações impactam no ambiente. No entanto, poderia trabalhar em mostrar uma maior abertura emocional e autenticidade para construir relações mais próximas e não apenas baseadas em objetivos partilhados.',
              },
              {
                title: 'Sugestão',
                description:
                  'Participar em atividades que fomentem a expressão emocional, como workshops de comunicação eficaz e grupos de debate centrados na conexão pessoal, para equilibrar o seu enfoque lógico com uma maior sensibilidade emocional.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem boas habilidades sociais, com uma grande capacidade para influenciar positivamente os outros através de uma comunicação clara e focada. No entanto, o seu enfoque na eficiência e na conquista de objetivos poderá ser interpretado como frieza ou distância em certos contextos.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar técnicas de comunicação emocional, onde o foco não esteja no resultado final, mas em partilhar experiências e sentimentos de maneira mais aberta e relaxada, para fortalecer as suas relações pessoais.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna da pessoa avaliada está orientada para a conquista de metas significativas. No entanto, poderia beneficiar de trabalhar em metas que não se foquem apenas no sucesso pessoal, mas também no desenvolvimento de um equilíbrio entre a sua vida profissional e pessoal.',
              },
              {
                title: 'Sugestão',
                description:
                  'Definir metas a curto prazo que incluam o desfrute de atividades não relacionadas com o seu desenvolvimento estratégico, para manter uma motivação mais equilibrada e sustentável a longo prazo.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fomentar a abertura à incerteza',
            description:
              'Aprender a aceitar que nem tudo pode ser planeado, permitindo-se ser mais flexível e aberto ao inesperado. Praticar a tomada de decisões rápidas em situações onde não tem o controlo total ajudará a fortalecer esta área.',
          },
          {
            title: 'Trabalhar na expressão emocional',
            description:
              'Participar em atividades que requeiram partilhar experiências pessoais e emoções sem um objetivo predeterminado, como workshops de criatividade ou escrita emocional.',
          },
          {
            title: 'Desenvolver uma perspetiva mais holística',
            description:
              'Fomentar o desfrute do processo e não apenas do resultado final. Realizar atividades recreativas que não impliquem um planeamento estrito ajudará a libertar a mente e a reduzir a rigidez.',
          },
          {
            title: 'Fortalecer as relações interpessoais',
            description:
              'Envolver-se em dinâmicas de grupo que se centrem mais na conexão emocional do que na consecução de metas, para equilibrar o enfoque estratégico com uma maior abertura interpessoal.',
          },
        ],
      },
      {
        pageBreak: true,
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            title: 'Desportos de estratégia e espontaneidade',
            description:
              'O xadrez, o badminton ou o paintball são ideais para desenvolver a capacidade de antecipação e estratégia. No entanto, recomenda-se combiná-los com atividades de reação rápida e espontânea, como o padel ou o basebol, para fomentar a adaptabilidade.',
          },
          {
            title: 'Práticas de improvisação teatral',
            description:
              'Participar em workshops de teatro de improvisação é uma excelente maneira de trabalhar na flexibilidade emocional e na capacidade de resposta rápida sem um plano prévio.',
          },
          {
            title: 'Atividades criativas sem estrutura definida',
            description:
              'Realizar workshops de pintura livre, aulas de dança ou fotografia sem guião pode ajudar a pessoa avaliada a sair da sua zona de conforto e explorar novas formas de expressão sem a necessidade de um resultado específico.',
          },
          {
            title: 'Série',
            description:
              '"Billions" Uma série que explora a complexidade da tomada de decisões estratégicas e o impacto emocional que estas têm nas relações pessoais e profissionais. Ideal para refletir sobre como o enfoque estratégico afeta a vida em geral.',
          },
          {
            title: 'Podcast',
            description:
              '"Freakonomics Radio" Um podcast que explora o lado oculto da tomada de decisões e como as estratégias influenciam diferentes aspetos da vida. Ideal para manter o interesse na estratégia enquanto se fomenta uma perspetiva mais ampla.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Risk" Um jogo clássico de estratégia e conquista que requer um planeamento cuidadoso e flexibilidade para adaptar-se aos movimentos dos outros jogadores. Ideal para combinar o pensamento estratégico com a adaptabilidade.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra um alto nível de habilidades estratégicas e de planeamento, o que lhe permite antecipar os desafios e desenhar soluções claras e eficazes. Graças à sua capacidade analítica, pode tomar decisões informadas e manter um enfoque orientado para os resultados, mesmo em ambientes complexos. Isto torna-a uma referência para gerir projetos de maneira estruturada, garantindo que cada passo esteja alinhado com um objetivo claro.',
          'No entanto, a sua forte orientação para a estratégia e a eficiência pode fazer com que, ocasionalmente, priorize os resultados acima das relações interpessoais ou do prazer do processo. É fundamental que trabalhe em desenvolver uma maior flexibilidade e abertura ao inesperado, aprendendo a valorizar tanto o caminho quanto a meta. Ao integrar a sua capacidade de planeamento com uma maior sensibilidade para o presente, a pessoa avaliada poderá alcançar um equilíbrio mais saudável e eficaz nas suas decisões.',
          'Ao encontrar este equilíbrio, não só poderá manter o seu alto rendimento, mas também se tornará uma referência de liderança que inspira outros a combinar a clareza estratégica com uma conexão mais profunda e autêntica com o ambiente. Assim, a pessoa avaliada alcançará um impacto positivo que vai além do sucesso individual, gerando relações interpessoais baseadas na confiança e no respeito.',
        ],
      },
    ],
    9: [
      {
        title: 'Introdução',
        content: [
          'Num mundo cada vez mais competitivo, onde as habilidades técnicas e o conhecimento académico costumam monopolizar a atenção, a inteligência emocional surgiu como um fator chave que diferencia as pessoas no seu sucesso tanto pessoal quanto profissional. Além do que se pode aprender em livros ou cursos, a inteligência emocional é o que permite às pessoas gerir as suas emoções, entender as dos outros e construir relações interpessoais sólidas e eficazes. Este conceito, popularizado pelo psicólogo Daniel Goleman, abrange uma série de competências que incluem a capacidade de reconhecer, compreender e gerir as próprias emoções, bem como influenciar positivamente as emoções dos outros. O interessante da inteligência emocional é que, ao contrário de algumas habilidades inatas, pode ser desenvolvida e aperfeiçoada com o tempo, o que a torna um recurso inestimável em qualquer contexto, seja pessoal ou profissional.',
          'A Nawaiam não se foca apenas em avaliar comportamentos e habilidades através da sua abordagem inovadora de gamificação, mas também pode ser uma ferramenta poderosa para ajudar as pessoas a descobrir e desenvolver a sua inteligência emocional. Através do nosso videojogo, cada pessoa tem a oportunidade de refletir sobre como gere as suas emoções, como se relaciona com o seu ambiente e como pode melhorar nestas áreas para alcançar o seu máximo potencial. Desde a gestão do stress até à tomada de decisões eficazes e à criação de ambientes de trabalho mais harmoniosos, a inteligência emocional é o catalisador que impulsiona tanto o crescimento individual quanto o coletivo. Na Nawaiam, acreditamos que o autoconhecimento e o desenvolvimento emocional não só geram melhores profissionais, mas também indivíduos mais conscientes, empáticos e resilientes.',
        ],
      },
      {
        title: 'Descrição do perfil de Inteligência Emocional',
        content: [
          'A pessoa avaliada apresenta um perfil de Líder Inspirador, caracterizado pela sua capacidade de motivar, guiar e gerar um impacto positivo nos outros através das suas ações e palavras. Costuma destacar-se pela sua habilidade de transmitir a sua visão com entusiasmo e convicção, o que lhe permite criar um ambiente de motivação e confiança onde os outros se sentem inspirados a seguir o seu exemplo. Esta combinação de motivação interna e habilidades sociais avançadas confere-lhe uma influência significativa, permitindo-lhe conectar-se com as pessoas de maneira autêntica e empática.',
          'No entanto, a pessoa avaliada também poderá enfrentar desafios relacionados com a gestão das suas próprias expectativas e a tendência a assumir um papel de apoio constante para os outros. Esta inclinação para a inspiração e a liderança poderá levá-la a priorizar as necessidades alheias acima das suas próprias, correndo o risco de esgotamento emocional ou de não se permitir tempo suficiente para refletir sobre o seu próprio bem-estar. Para alcançar um desenvolvimento mais equilibrado, é fundamental que a pessoa avaliada trabalhe na autogestão e no estabelecimento de limites saudáveis, assegurando que a sua motivação para apoiar e inspirar não se torne um fardo. Ao encontrar um equilíbrio entre o seu impulso para liderar e o seu autocuidado, poderá continuar a inspirar aqueles que a rodeiam sem comprometer o seu próprio bem-estar.',
        ],
      },
      {
        title: 'Competências Emocionais',
        content: [],
        list: [
          {
            title: 'Autoconsciência',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem um nível de autoconsciência que lhe permite identificar as suas emoções com clareza e entender como estas influenciam o seu estilo de liderança. No entanto, poderia beneficiar de um trabalho mais profundo na identificação dos seus limites pessoais.',
              },
              {
                pageBreak: true,
                title: 'Sugestão',
                description:
                  'Praticar a autoavaliação no final de cada jornada para identificar que emoções foram geradas durante o dia e que situações poderiam ter sido geridas com maior equilíbrio entre o apoio aos outros e o autocuidado.',
              },
            ],
          },
          {
            title: 'Autogestão',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem uma grande capacidade para gerir as suas respostas emocionais e manter o foco nos seus objetivos, mesmo em ambientes de alta pressão. No entanto, poderia trabalhar em criar momentos específicos de desconexão para evitar o esgotamento pelo seu alto nível de compromisso.',
              },
              {
                title: 'Sugestão',
                description:
                  'Incorporar pausas planeadas na sua rotina e atividades de relaxamento que lhe permitam renovar a sua energia sem se sentir culpada por não estar sempre disponível para os outros.',
              },
            ],
          },
          {
            title: 'Empatia',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A empatia é um dos pontos mais fortes da pessoa avaliada, o que lhe permite conectar-se de maneira autêntica com os outros e entender as suas necessidades. No entanto, poderia trabalhar em equilibrar o seu desejo de ajudar com a capacidade de manter-se firme nas suas próprias decisões.',
              },
              {
                title: 'Sugestão',
                description:
                  'Praticar a escuta ativa sem assumir o papel de "solucionador" de todos os problemas, permitindo que os outros também desenvolvam a sua própria autonomia.',
              },
            ],
          },
          {
            title: 'Habilidades Sociais',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A pessoa avaliada tem excelentes habilidades sociais, sendo percebida como uma figura de apoio e guia para aqueles que a rodeiam. A sua capacidade de transmitir mensagens de maneira eficaz e motivar os outros é notável, mas poderia beneficiar de focar-se mais em delegar responsabilidades para não assumir todo o peso da liderança.',
              },
              {
                title: 'Sugestão',
                description:
                  'Realizar exercícios de delegação em grupos de trabalho ou em projetos pessoais, cedendo a liderança em algumas ocasiões para fomentar a autogestão na equipa.',
              },
            ],
          },
          {
            title: 'Motivação Interna',
            description: '',
            subList: [
              {
                title: 'Área atual',
                description:
                  'A motivação interna da pessoa avaliada é excecional, impulsionada por um desejo genuíno de alcançar as suas metas e ajudar os outros a alcançar as suas. No entanto, este nível de motivação pode levá-la a ignorar sinais de esgotamento.',
              },
              {
                title: 'Sugestão',
                description:
                  'Definir objetivos de autocuidado como parte do seu plano de desenvolvimento, assegurando que a sua motivação não se traduza unicamente em conquistas externas, mas também em bem-estar pessoal.',
              },
            ],
          },
        ],
      },
      {
        title: 'Orientação, Apoio e Recomendações',
        content: [
          'Nesta secção, vamos conversar sobre como a pessoa avaliada pode continuar a desenvolver-se através de algumas recomendações práticas. Exploraremos tanto estratégias específicas para potenciar as suas competências emocionais quanto atividades complementares, como desportos, entretenimento e recursos de aprendizagem.',
        ],
        list: [
          {
            title: 'Fomentar o autocuidado',
            description:
              'Estabelecer rotinas de autocuidado que incluam tanto atividades recreativas quanto momentos de reflexão pessoal, para evitar o esgotamento emocional.',
          },
          {
            title: 'Trabalhar na delegação de responsabilidades',
            description:
              'Aprender a delegar tarefas de maneira eficaz, permitindo que outros assumam papéis de liderança sob a sua orientação e apoio.',
          },
          {
            title: 'Fortalecer a autonomia emocional',
            description:
              'Estabelecer limites claros e lembrar que cuidar de si mesmo é parte da liderança, assegurando que o seu desejo de apoiar não se torne um fardo excessivo.',
          },
          {
            title:
              'Equilibrar o desejo de ajudar com a capacidade de dizer "não"',
            description:
              'Praticar técnicas de assertividade para expressar quando necessita de tempo para si mesmo, sem perder o seu espírito de apoio e liderança.',
          },
        ],
      },
      {
        title: 'Recomendações Adicionais',
        content: [
          'Para complementar o desenvolvimento das suas competências emocionais, é fundamental que se mantenha ativo tanto física quanto mentalmente. Aqui estão algumas sugestões que podem potenciar as suas habilidades:',
        ],
        list: [
          {
            pageBreak: true,
            title: 'Desportos que combinam liderança e colaboração',
            description:
              'Atividades como o futebol, basquetebol ou remo em equipa permitem à pessoa exercitar as suas habilidades de liderança num ambiente onde o sucesso depende da colaboração. Estas atividades ajudam a equilibrar a motivação interna com a capacidade de confiar nos outros para alcançar objetivos conjuntos.',
          },
          {
            title: 'Práticas de relaxamento ativo',
            description:
              'O yoga ou o tai chi são ideais para manter um foco no bem-estar físico e mental, ao mesmo tempo que permitem um espaço para a autorreflexão e a renovação de energia.',
          },
          {
            title: 'Atividades de voluntariado guiadas',
            description:
              'Participar em projetos de voluntariado onde possa guiar outros sem assumir todo o peso da liderança é ideal para equilibrar o seu desejo de ajudar com a capacidade de delegar e fomentar a autonomia dos outros.',
          },
          {
            title: 'Série',
            description:
              '"The West Wing". Uma série que explora a liderança, a tomada de decisões e o impacto que um líder tem no seu ambiente. Ideal para refletir sobre como equilibrar a motivação interna com o autocuidado e a gestão das expectativas.',
          },
          {
            title: 'Podcast',
            description:
              '"HBR IdeaCast". Um podcast que aborda temas de liderança, motivação e equilíbrio pessoal, com ferramentas práticas para melhorar a capacidade de influenciar positivamente sem comprometer o próprio bem-estar.',
          },
          {
            title: 'Jogo de tabuleiro',
            description:
              '"Pandemic: Legacy". Um jogo cooperativo onde a equipa deve trabalhar em conjunto para superar desafios globais. Ideal para praticar a tomada de decisões colaborativas e fortalecer a capacidade de delegar responsabilidades.',
          },
        ],
      },
      {
        title: 'Conclusão',
        content: [
          'A pessoa avaliada demonstra um nível excecional de habilidades de liderança e motivação, o que a torna uma referência natural para aqueles que a rodeiam. A sua capacidade de guiar os outros com entusiasmo, transmitir a sua visão de maneira clara e gerar um ambiente de apoio e confiança confere-lhe um alto nível de influência positiva em qualquer contexto. Esta combinação de motivação interna e habilidades sociais avançadas não só impulsiona o seu próprio crescimento, mas também cria um impacto profundo naqueles que a seguem, motivando-os a alcançar os seus próprios objetivos e a desenvolver o seu potencial.',
          'No entanto, o seu forte desejo de apoiar e guiar os outros pode levá-la a assumir responsabilidades adicionais ou a colocar as necessidades do seu ambiente acima das suas próprias, gerando um risco de esgotamento emocional ou de desmotivação quando sente que não consegue cumprir as expectativas que se autoimpõe. Este impulso constante para ser uma fonte de inspiração e apoio poderá, ocasionalmente, fazer com que a pessoa avaliada negligencie o seu próprio bem-estar e se sinta presa num ciclo de autoexigência e falta de tempo pessoal.',
          'Para manter a sua capacidade de liderança a longo prazo, é importante que a pessoa avaliada aprenda a estabelecer limites saudáveis e a equilibrar o seu papel de apoio com um espaço dedicado ao autocuidado e à reflexão pessoal. Aprender a delegar responsabilidades, permitindo que outros também assumam papéis de liderança, e aceitar que nem sempre deve ser a fonte principal de motivação pode ajudá-la a reduzir a carga emocional que sente e a preservar a sua energia para momentos realmente cruciais.',
          'Com o tempo, ao aperfeiçoar a sua capacidade de equilibrar a sua motivação interna com o autocuidado, a pessoa avaliada poderá tornar-se um modelo de liderança sustentável e equilibrada. Não só poderá continuar a inspirar os outros com a sua visão e o seu exemplo, mas também demonstrar que a verdadeira liderança se baseia em saber quando guiar e quando dar um passo atrás para permitir que os outros cresçam. Esta abordagem não só lhe permitirá manter um nível alto de energia e compromisso, mas também contribuirá para criar um ambiente em que todos se sintam capacitados e motivados a contribuir.',
          'Em última análise, a pessoa avaliada poderá continuar a influenciar positivamente o seu ambiente, não só pelas suas conquistas e a sua capacidade de motivar, mas também pela sua habilidade de manter-se autêntica, conectada com as suas próprias necessidades e disposta a inspirar os outros a partir de um lugar de equilíbrio e bem-estar integral. Com esta abordagem, o impacto da sua liderança será ainda mais profundo, promovendo um desenvolvimento não só nos seus próprios projetos, mas também no bem-estar e crescimento daqueles que a rodeiam',
        ],
      },
    ],
  },
};
